// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-01T17:22:54.557Z
// Property: NOVO Stockbridge (ID: 6767906449167443)
// Collections: 22 amenities, 3 floorplans (live), 69 photos, 34 POIs, 4 reviews, 3 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162258",
  "multihub_property_id": "6767906449167443",
  "property_external_id": "100160106",
  "property_zillow_url": "https://www.zillow.com/apartments/stockbridge-ga/novo-stockbridge/CjCB6F/",
  "property_apartments_url": "https://www.apartments.com/novo-stockbridge-stockbridge-ga/svm7c95/",
  "property_google_business_url": "https://www.google.com/maps/place/Novo+Stockbridge/data=!4m2!3m1!1s0x0:0xdc9b65ee502744ab?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "9863957055",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": "5605579",
  "property_status": null,
  "property_slug": "novo-stockbridge",
  "property_name": "NOVO Stockbridge",
  "property_website_url": "https://liveatnovostockbridge.com/",
  "property_domain": "https://liveatnovostockbridge.com/",
  "property_address": "3151 Mt Zion Rd",
  "property_full_address": "3151 Mt Zion Rd, Stockbridge, GA 30281",
  "property_address_1": "3151 Mt Zion Rd",
  "property_address_2": null,
  "property_address_city": "Stockbridge",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30281",
  "property_address_country": "US",
  "property_address_county": "Clayton County",
  "property_neighborhood_address": "Clayton County",
  "property_address_latitude": "33.552165",
  "property_address_longitude": "-84.28811499999999",
  "property_email": null,
  "property_phone": "(770) 628-5032",
  "property_call_tracking_phone": "2294751351",
  "property_company_name": "Axia Residential (ARC Living)",
  "property_company_url": "https://www.axiares.com/",
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "At NOVO Stockbridge, your lifestyle is elevated with spacious floor plans, stunning chef-inspired kitchens, and resort-style amenities. Unwind in our pristine swimming pool, explore the bark park, or enjoy outdoor gatherings by the fire pits. Embrace modern living today—browse our availability or schedule a tour to see your future home!",
  "property_long_description": "Welcome to NOVO Stockbridge, where comfort meets style in the heart of Stockbridge, GA! Our thoughtfully designed apartment community offers a diverse selection of floor plans, including one, two, and three-bedroom options tailored to fit your lifestyle. Each residence is adorned with upscale features such as stunning 42\" shaker-style cabinetry, modern stainless steel appliances, and elegant granite countertops, ensuring that your chef-inspired kitchen is both functional and fashionable. Our spacious layouts boast 9' ceilings and luxurious wood-style flooring, providing an inviting atmosphere that you’ll love coming home to.\n\nAt NOVO Stockbridge, our exceptional amenities go beyond your front door. Dive into relaxation at our resort-inspired swimming pool complete with a sun deck, or savor evenings around our outdoor fire pits. For residents with furry friends, our bark park is the perfect spot for playtime! Families will appreciate our on-site playground and scenic walking trail, perfect for evening strolls. Our state-of-the-art fitness center is ready for your workout sessions, while our resident clubroom offers a cozy space to unwind.\n\nWith additional perks such as detached garages, available storage closets, WiFi in community spaces, and convenient USB outlets, NOVO Stockbridge is designed for modern living. Life here means convenience and luxury at your fingertips!\n\nDon’t wait – find your new home today! Browse our availability or schedule a tour to experience our vibrant community firsthand. Embrace the lifestyle you deserve at NOVO Stockbridge!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-f986-7228-bc8f-cf2a42e5592a.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and cabanas next to apartment buildings at sunset.",
    "public_id": "019d72d0-f986-7228-bc8f-cf2a42e5592a",
    "storage_key": "property/6767906449167443/019d72d0-f986-7228-bc8f-cf2a42e5592a.webp",
    "width": 1800,
    "height": 700
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "293",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.4914675767918",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security deposit: $500.00 (refundable).",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": "Maximum of 2 pets per unit. Breed and weight restrictions apply.",
  "property_pet_policy_description": "Cats and dogs welcome. Maximum of 2 pets per unit. Please contact leasing office for more information.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://theleilastockbridge.prospectportal.com/Stockbridge/The Leila Stockbridge",
  "property_resident_portal_url": "https://theleilastockbridge.residentportal.com/auth",
  "property_apply_now_url": "https://theleilastockbridge.prospectportal.com/Apartments/module/application_authentication/popup/false/kill_session/1/property/100160106/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-f52a-759f-bcb1-b4ec0b172fcd.webp",
  "property_primary_logo_media": {
    "alt_text": "Graphic with \"Hello Spring\" text surrounded by tulips and daisies.",
    "public_id": "019d72d0-f52a-759f-bcb1-b4ec0b172fcd",
    "storage_key": "property/6767906449167443/019d72d0-f52a-759f-bcb1-b4ec0b172fcd.webp",
    "width": 600,
    "height": 350
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7872-a070-714c-96f3-20198411e200.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d7872-a070-714c-96f3-20198411e200",
    "storage_key": "property/6767906449167443/019d7872-a070-714c-96f3-20198411e200.webp",
    "width": 792,
    "height": 343
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7872-94dc-728f-b493-b2a3a9c58a00.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d7872-94dc-728f-b493-b2a3a9c58a00",
    "storage_key": "property/6767906449167443/019d7872-94dc-728f-b493-b2a3a9c58a00.webp",
    "width": 792,
    "height": 343
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
  "property_company_logo_media": {
    "alt_text": "AXIA RESIDENTIAL BY ARC logo",
    "public_id": "019d54d9-0a7f-7644-86f7-60a98c66fa2f",
    "storage_key": "company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
    "width": 3072,
    "height": 1849
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "AXIA Residential by ARC logo",
    "public_id": "019d54d9-c530-7559-a71a-a1a4613d29fc",
    "storage_key": "company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
    "width": 125,
    "height": 75
  },
  "property_primary_color": "#47A23F",
  "property_secondary_color": "#f0f0f0",
  "property_font_color": "#464646",
  "property_color_4": null,
  "property_color_3": "#373A36",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "756 - 1248",
  "property_sqft_min": "756",
  "property_sqft_max": "1248",
  "property_price_range": "$1395 - $2675",
  "property_price_min": "1395",
  "property_price_max": "2675",
  "property_available_units": 22,
  "property_facebook_url": "https://www.facebook.com/TheLeilaStockbridge",
  "property_instagram_url": "https://www.instagram.com/novostockbridgeapts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJIQS1Eyn59IgRq0QnUO5lm9w",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/magnolia-place-at-stockbridge-stockbridge-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to NOVO Stockbridge",
  "property_home_romance_title": "Embrace the Charm of Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to NOVO Stockbridge, where modern living meets comfort. Choose from our spacious one, two, and three-bedroom floor plans, designed with chef-inspired kitchens and luxurious finishes. Enjoy resort-style amenities, including a sparkling swimming pool, a vibrant bark park, and serene walking trails. Your ideal lifestyle awaits in Stockbridge!",
  "property_home_floorplans_blurb": "At NOVO Stockbridge, your ideal home awaits in the heart of Stockbridge, GA. Choose from our thoughtfully designed one, two, and three-bedroom apartments that blend comfort and style. Each layout offers a unique experience tailored to your lifestyle. Browse our available options to find the perfect fit for you!",
  "property_home_gallery_blurb": "At NOVO Stockbridge, your dream home awaits in a vibrant community adorned with stunning one to three-bedroom floor plans. Enjoy luxurious amenities like a resort-style pool, state-of-the-art fitness center, and gourmet kitchens with granite counters. Picture yourself living here and embrace the lifestyle you deserve in Stockbridge, GA!",
  "property_home_neighborhood_blurb": "At NOVO Stockbridge, your lifestyle thrives amid a vibrant community. Unwind at nearby Reynolds Nature Preserve, stay active with Fitness Connection, or enjoy the thrill of Spivey Splash Water Park. With spacious one, two, and three-bedroom floor plans, convenience and comfort are within reach. See what's around our community today!",
  "property_home_reviews_blurb": "At NOVO Stockbridge, residents rave about the “welcoming atmosphere and exceptional amenities.” Nestled in the heart of Stockbridge, GA, our vibrant community is where comfort meets convenience. Dive into our world—see what our residents have to say about living at our community and experience the difference for yourself!",
  "property_neighborhood_blurb": "At NOVO Stockbridge, your home is surrounded by vibrant community gems. Enjoy nature at Reynolds Nature Preserve, embrace fitness at LA Fitness, or explore local landmarks like the Road to Tara Museum. Venture to Clayton State University or enjoy family fun at Spivey Splash Water Park—there’s something for everyone nearby!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Experience a lifestyle of comfort and convenience at NOVO Stockbridge. Choose from thoughtfully designed one to three-bedroom floor plans, paired with luxurious amenities like a resort-inspired pool, state-of-the-art fitness center, and outdoor kitchen. Unwind in style—each apartment features designer finishes and chef-inspired kitchens, perfect for modern living.",
  "property_applynow_blurb": "At NOVO Stockbridge, upscale living meets modern comfort in our thoughtfully designed one, two, and three-bedroom apartments. Enjoy resort-style amenities, from a sparkling pool and outdoor kitchens to a state-of-the-art fitness center. Craft memorable moments—join a community that feels like home! Lease online today for your ideal lifestyle.",
  "property_contactus_blurb": "At NOVO Stockbridge, we offer a variety of thoughtfully designed floor plans, including one, two, and three-bedroom apartments, tailored to suit your lifestyle. Each space enhances comfort and functionality. Have questions? Contact our leasing team today to discover how NOVO can be your next home sweet home!",
  "property_faqs_blurb": "At NOVO Stockbridge, we offer thoughtfully designed one, two, and three-bedroom floor plans to suit your lifestyle. Have questions? Our FAQs page provides insightful answers to help you navigate our vibrant community in Stockbridge, GA. Browse now to discover the perfect fit for your new home!",
  "property_floorplans_blurb": "At NOVO Stockbridge, where style meets comfort, you’ll find thoughtfully designed floor plans to suit your lifestyle. Choose from spacious one, two, or three-bedroom options that elevate your living experience. Browse our available apartment homes and uncover the perfect space tailored just for you in Stockbridge, GA.",
  "property_gallery_blurb": "At NOVO Stockbridge, picture a vibrant lifestyle where every detail enhances your living experience. Choose from spacious one, two, or three-bedroom apartments featuring chef-inspired kitchens, designer finishes, and serene garden tubs. Unwind by the resort-inspired pool, savor outdoor kitchens, or stroll along our scenic walking trail. Welcome home!",
  "property_interactivemap_blurb": "At NOVO Stockbridge, elevate your lifestyle with our thoughtfully designed one, two, and three-bedroom apartments. Enjoy luxurious amenities like a resort-inspired pool, state-of-the-art fitness center, and vibrant community spaces. Use our interactive community map to find your perfect home in Stockbridge, GA—where comfort meets convenience!",
  "property_pets_blurb": "At NOVO Stockbridge, your furry friends are part of the family! Nestled in scenic Stockbridge, GA, our pet-friendly community embraces up to two pets. With a spacious setting and easy access to nearby parks, you and your pets can enjoy a vibrant lifestyle, tailored with your comfort in mind.",
  "property_referafriend_blurb": "At NOVO Stockbridge, your dream home awaits with innovative one, two, and three-bedroom floor plans designed for modern living. Share the joy of our vibrant community—refer a friend today, and let great friendships thrive in a space where comfort meets connection. Join us in creating a welcoming neighborhood!",
  "property_residentaccess_blurb": "At NOVO Stockbridge, our thoughtfully designed one, two, and three-bedroom floor plans offer the perfect blend of comfort and style. Enhance your living experience by accessing our resident portal, where you can easily pay rent, schedule maintenance, and stay connected to your community. Join us today!",
  "property_reviews_blurb": "At NOVO Stockbridge, residents rave about their experience, highlighting the \"welcoming atmosphere and attentive staff.\" With lush surroundings and modern amenities, our community is designed for comfort and connection. Curious about life here? See what our residents have to say about living at our vibrant Stockbridge community!",
  "property_created_at": "1775747739195",
  "property_scheduletour_blurb": "At NOVO Stockbridge, our thoughtfully designed one, two, and three-bedroom floor plans offer the perfect blend of comfort and style. Experience the vibrant community atmosphere in Stockbridge, GA, and see what our residents love about calling NOVO home. Schedule a tour today to envision your next chapter!",
  "property_thankyou_blurb": "Thank you for your interest in NOVO Stockbridge! Nestled in the heart of Stockbridge, GA, our thoughtfully designed one, two, and three-bedroom floor plans promise comfort and style. A team member will be in touch soon to help you step into your new home. Welcome to your future!",
  "property_virtualtours_blurb": "Step into NOVO Stockbridge, where stunning one, two, and three-bedroom apartments await. Nestled in vibrant Stockbridge, GA, our community blends modern comforts with stylish designs. Experience your future home by taking a virtual tour today, and envision the perfect lifestyle that awaits you!",
  "property_copyright": "2026 All Rights Reserved. NOVO Stockbridge",
  "property_seo_title_home": "NOVO Stockbridge |  Apartments in Stockbridge, GA",
  "property_seo_description_home": "Experience the blend of luxury and comfort at NOVO Stockbridge. Spacious floor plans, upscale amenities, and a vibrant community await your new lifestyle!",
  "property_seo_title_floorplans": "Floor Plans | Stockbridge, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at NOVO Stockbridge! From cozy one-bedrooms to spacious three-bedrooms, we have the perfect floor plan waiting for you.",
  "property_seo_title_amenities": "Amenities | Stockbridge, GA Apartments for Rent",
  "property_seo_description_amenities": "Discover luxury at NOVO Stockbridge! Enjoy amenities, chef-inspired kitchens, and spacious living. Embrace comfort and community today!",
  "property_seo_title_gallery": "Gallery | Apartments in Stockbridge, GA",
  "property_seo_description_gallery": "Envision your life at NOVO Stockbridge! Experience luxury in our stunning community with resort-style amenities, designer finishes, and spacious floor plans.",
  "property_seo_title_virtualtours": "Virtual Tours | NOVO Stockbridge Apartments",
  "property_seo_description_virtualtours": "Step into your future home at NOVO Stockbridge! Take a virtual tour of our charming one, two, and three-bedroom apartments in scenic Stockbridge, GA.",
  "property_seo_title_interactivemap": "Interactive Map | NOVO Stockbridge Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at NOVO Stockbridge! Choose from chic one to three-bedroom apartments with great amenities. Start your journey today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Stockbridge, GA",
  "property_seo_description_neighborhood": "Uncover the vibrant charm of Stockbridge, GA at NOVO Stockbridge. From local hotspots to serene parks, discover the perfect blend of convenience and comfort!",
  "property_seo_title_contact": "Contact Us | NOVO Stockbridge",
  "property_seo_description_contact": "Have questions about NOVO Stockbridge in Stockbridge, GA? Our leasing team is ready to help you find the perfect one, two, or three-bedroom home!",
  "property_seo_title_faqs": "FAQs | Apartments in Stockbridge, GA",
  "property_seo_description_faqs": "Discover spacious floor plans and luxury amenities for comfortable living at NOVO Stockbridge. Your questions will be answered here!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Stockbridge, GA",
  "property_seo_description_reviews": "Experience life at NOVO Stockbridge, where modern comforts meet vibrant community living. Read resident reviews and see why our apartments feel like home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Stockbridge, GA",
  "property_seo_description_applynow": "Find your perfect home at NOVO Stockbridge! Enjoy modern amenities, spacious layouts, and stunning design. Lease online today and elevate your lifestyle!",
  "property_seo_title_residentaccess": "Resident Access | NOVO Stockbridge",
  "property_seo_description_residentaccess": "Log in to NOVO Stockbridge's resident portal! Manage rent, request maintenance, and access community updates—all at your fingertips. Your home, your way!",
  "property_seo_title_referafriend": "Refer A Friend | NOVO Stockbridge",
  "property_seo_description_referafriend": "Refer a friend to NOVO Stockbridge and build a vibrant community together! Great friends make great neighbors—share the joy of living in Stockbridge today!",
  "property_seo_title_scheduletour": "Schedule a Tour | NOVO Stockbridge",
  "property_seo_description_scheduletour": "Experience modern living at NOVO Stockbridge. Schedule your tour today and envision a vibrant lifestyle filled with luxury and comfort in Stockbridge, GA!",
  "property_seo_title_privacy": "Privacy Policy | NOVO Stockbridge",
  "property_seo_description_privacy": "At NOVO Stockbridge, your privacy matters. Discover how we protect your information and enjoy peace of mind. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | NOVO Stockbridge",
  "property_seo_description_accessibility": "At NOVO Stockbridge, we prioritize digital inclusion and accessibility, ensuring all residents can connect and thrive in our vibrant community. Join us today!",
  "property_seo_title_sitemap": "Sitemap | NOVO Stockbridge",
  "property_seo_description_sitemap": "Uncover the seamless layout of NOVO Stockbridge! Navigate our sitemap for easy access to amenities, floor plans, and all that makes our community unique.",
  "property_seo_title_thankyou": "Thank You | NOVO Stockbridge",
  "property_seo_description_thankyou": "Thank you for reaching out! We’re excited to connect and help you find your perfect home at NOVO Stockbridge, where comfort meets style in Stockbridge, GA.",
  "property_seo_title_pets": "Pet Policy | Apartments in Stockbridge, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790793478352",
  "amenities": [
    {
      "id": "custom_4b540ac2-6ff7-403a-86ef-e14424185eb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Detached Garages",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bea0097a-a498-4611-98c3-b4a524c95465",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "State‑of‑the‑Art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_232d3d3b-7051-4f7b-853f-54565618aad1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Clubroom",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3ce06b36-2024-4657-bf3a-a324f2870982",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f14eb300-250c-4076-93e6-0d353b2ac7d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f0161124-2489-41ae-bb21-939c7b07d202",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Resort‑Inspired Swimming Pool with Sun Deck",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a31be9d4-e589-4ef6-a440-76db863075d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Fire Pits",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c313d48e-fd58-42e7-9c85-eec88c25cce9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Walking Trail",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2e5b9757-74b3-46e1-8ce9-e168d99a4e3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Kitchen",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4af2de65-face-4094-ad50-e574cae1a893",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Garages and Storage Closets Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9e59685d-0f5b-4104-b774-284d135a4b82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "WiFi in Community Spaces",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_55e3cac1-e54f-4ae1-b73b-9061191d259b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bd2122be-63a2-4c7b-85a0-d48313f470a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "42\" Shaker‑Style Cabinetry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a343899e-4f04-4c76-8409-2d4144576216",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Counters",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5548d43e-a24e-4b09-bf40-388723833970",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Movable Kitchen Islands",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bad3c6cb-3d23-4289-8312-1352aa5603f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "USB Outlets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0a887af0-051c-4dbb-9bd5-dee06f9068d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Garden Tubs",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bea7b5b6-f883-4605-aeb6-50da04d199dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Washer / Dryer Included",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c7ca3db4-576b-439d-bdfc-3af27140f0c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "9' Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_892f11fd-ccc6-4fe8-8b58-e8ea20de006b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑Style Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_63d888e4-83c1-4933-ab71-43cc2553af15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Designer Finishes",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3775ebf2-a375-4062-b039-ccd8c8b97dbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "external_id": "false",
      "title": "Chef Inspired Kitchens",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_51bfde6a-ba5c-4f32-8a2a-99f8e94b011b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-2576-74a3-85a7-462bb8f843e1.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with parking lots and surrounding trees.",
        "public_id": "019d7871-2576-74a3-85a7-462bb8f843e1",
        "storage_key": "property/6767906449167443/019d7871-2576-74a3-85a7-462bb8f843e1.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "An aerial view showcasing the apartment complex, featuring multiple buildings, well-maintained parking lots, and a backdrop of lush green trees.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings with parking lots and surrounding trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_98bc84f6-2bd4-4937-b9b0-8201a64c55b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-08a6-72ac-9970-642c3693fd52.webp",
      "image_media": {
        "alt_text": "Modern swimming pool with lounge chairs and cabanas at sunset.",
        "public_id": "019d7871-08a6-72ac-9970-642c3693fd52",
        "storage_key": "property/6767906449167443/019d7871-08a6-72ac-9970-642c3693fd52.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning swimming pool, complete with comfortable lounge chairs and private cabanas, all set against a beautiful sunset sky.",
      "link": "",
      "alt_text": "Modern swimming pool with lounge chairs and cabanas at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_536b6893-ae01-44de-aef6-03bed51afc05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-3b60-73f3-b166-bf4cdd4a5094.webp",
      "image_media": {
        "alt_text": "The community lounge area features a large wooden dining table with black chairs, a sectional sofa, and modern decor.",
        "public_id": "019d7871-3b60-73f3-b166-bf4cdd4a5094",
        "storage_key": "property/6767906449167443/019d7871-3b60-73f3-b166-bf4cdd4a5094.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed community lounge, complete with comfortable seating, a large dining table, and stylish decor. Perfect for residents to connect and unwind.",
      "link": "",
      "alt_text": "The community lounge area features a large wooden dining table with black chairs, a sectional sofa, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a8ce1700-242b-49a0-826f-468504460593",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-375c-73e8-9279-1c716d978441.webp",
      "image_media": {
        "alt_text": "Fitness center with rowing machine, dumbbells, and weight machines.",
        "public_id": "019d7871-375c-73e8-9279-1c716d978441",
        "storage_key": "property/6767906449167443/019d7871-375c-73e8-9279-1c716d978441.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, free weights, and strength training machines.",
      "link": "",
      "alt_text": "Fitness center with rowing machine, dumbbells, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_44ec92d0-ef11-4c75-9811-9a5dea21b048",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-2124-763b-987d-a5958501969f.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with a parking lot in front.",
        "public_id": "019d7871-2124-763b-987d-a5958501969f",
        "storage_key": "property/6767906449167443/019d7871-2124-763b-987d-a5958501969f.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "View of modern apartment buildings with a spacious parking lot and surrounding greenery.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with a parking lot in front.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_599e320a-859d-4afe-80c1-d34c4f1f218c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-3211-7798-b016-e1a6acca94fa.webp",
      "image_media": {
        "alt_text": "Gym with weight rack, medicine balls, kettlebells, barbells, and TRX equipment.",
        "public_id": "019d7871-3211-7798-b016-e1a6acca94fa",
        "storage_key": "property/6767906449167443/019d7871-3211-7798-b016-e1a6acca94fa.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Fully equipped fitness center featuring a functional training rig, weightlifting equipment, and cardio machines. Stay active and energized in our modern gym.",
      "link": "",
      "alt_text": "Gym with weight rack, medicine balls, kettlebells, barbells, and TRX equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fd357b08-572a-4bf5-bf2b-1a5fb25ee259",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-34cf-735d-9b30-907ee9b7828f.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, stair climbers, and free weights.",
        "public_id": "019d7871-34cf-735d-9b30-907ee9b7828f",
        "storage_key": "property/6767906449167443/019d7871-34cf-735d-9b30-907ee9b7828f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features a variety of cardio machines and free weights to help you stay active and healthy.",
      "link": "",
      "alt_text": "Fitness center with treadmills, stair climbers, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_da75230a-8b53-4c4f-aeec-e916071ab8ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-160e-778f-9263-d3d9a176bb7c.webp",
      "image_media": {
        "alt_text": "Modern apartment complex with a white clubhouse and a large apartment building in the background.",
        "public_id": "019d7871-160e-778f-9263-d3d9a176bb7c",
        "storage_key": "property/6767906449167443/019d7871-160e-778f-9263-d3d9a176bb7c.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover this modern apartment community featuring a sleek white clubhouse and a multi-story apartment building, surrounded by lush trees and ample parking.",
      "link": "",
      "alt_text": "Modern apartment complex with a white clubhouse and a large apartment building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fece29a5-c514-4d22-ac95-99246ec14c88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-2c3b-744f-aa9e-e36bea10ded7.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and decorative shelving.",
        "public_id": "019d7871-2c3b-744f-aa9e-e36bea10ded7",
        "storage_key": "property/6767906449167443/019d7871-2c3b-744f-aa9e-e36bea10ded7.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A contemporary kitchen featuring sleek gray cabinetry, a deep sink with a black faucet, and stylish open shelving displaying decorative items. The space is equipped with a microwave and a large stainless steel refrigerator.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and decorative shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_24b25967-0e77-444d-83f1-f9c88828c5db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-2666-704c-8791-cd5b01039c38.webp",
      "image_media": {
        "alt_text": "Modern communal lounge with comfortable seating, large television, and a wet bar.",
        "public_id": "019d7871-2666-704c-8791-cd5b01039c38",
        "storage_key": "property/6767906449167443/019d7871-2666-704c-8791-cd5b01039c38.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish communal lounge, featuring ample seating, a large TV, and a convenient wet bar area.",
      "link": "",
      "alt_text": "Modern communal lounge with comfortable seating, large television, and a wet bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a3d9f779-1132-49d7-a272-a17506f321f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-2c22-758a-b8f2-69058d44beeb.webp",
      "image_media": {
        "alt_text": "Community lounge area with coffee bar, seating, and modern decor.",
        "public_id": "019d7871-2c22-758a-b8f2-69058d44beeb",
        "storage_key": "property/6767906449167443/019d7871-2c22-758a-b8f2-69058d44beeb.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Relax and recharge in our stylish community lounge, featuring a complimentary coffee bar and comfortable seating areas perfect for work or socializing.",
      "link": "",
      "alt_text": "Community lounge area with coffee bar, seating, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_abe3250c-2b82-4ce1-834e-c32c9347af30",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-1187-702f-95ef-359d18401525.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with clubhouse in background",
        "public_id": "019d7871-1187-702f-95ef-359d18401525",
        "storage_key": "property/6767906449167443/019d7871-1187-702f-95ef-359d18401525.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Enjoy our luxurious resort-style swimming pool, perfect for relaxing or entertaining. Surrounded by comfortable lounge chairs and overlooking the modern clubhouse, it's the ideal spot to unwind.",
      "link": "",
      "alt_text": "Resort-style swimming pool and lounge chairs with clubhouse in background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_be471b63-0647-45f3-9ac9-db1f46c29802",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-22d8-77cd-9e5a-1a35e5cbe376.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex surrounded by lush green trees.",
        "public_id": "019d7871-22d8-77cd-9e5a-1a35e5cbe376",
        "storage_key": "property/6767906449167443/019d7871-22d8-77cd-9e5a-1a35e5cbe376.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Discover modern apartment living in this beautifully designed community, nestled amidst a scenic, tree-lined landscape.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex surrounded by lush green trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b2a098a2-a94a-4edd-a48a-87dbe25622dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-17d0-759b-8181-bf478944c7cd.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with parking lot and NOVO signage.",
        "public_id": "019d7871-17d0-759b-8181-bf478944c7cd",
        "storage_key": "property/6767906449167443/019d7871-17d0-759b-8181-bf478944c7cd.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "View of the NOVO apartment building exterior, featuring a contemporary design, ample parking, and professional landscaping.",
      "link": "",
      "alt_text": "Modern apartment building exterior with parking lot and NOVO signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_822e5e4f-cac5-4422-8965-2ce39ee2d53c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-04ad-723a-8720-6c91a099f6e9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and cabanas at a multifamily property.",
        "public_id": "019d7871-04ad-723a-8720-6c91a099f6e9",
        "storage_key": "property/6767906449167443/019d7871-04ad-723a-8720-6c91a099f6e9.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool with ample lounge seating and private cabanas, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and cabanas at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_33a5c149-d332-4471-9dba-3ceb4910cafb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-0e76-753f-9c8b-4cb97d180dbc.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and cabanas.",
        "public_id": "019d7871-0e76-753f-9c8b-4cb97d180dbc",
        "storage_key": "property/6767906449167443/019d7871-0e76-753f-9c8b-4cb97d180dbc.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge chairs and private cabanas for ultimate relaxation.",
      "link": "",
      "alt_text": "Luxury swimming pool with lounge chairs and cabanas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_96ff7115-1eaa-4e86-a3fc-7a056d09acbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-1069-7628-a8a7-ff0cdde3967a.webp",
      "image_media": {
        "alt_text": "Resort-style pool with lounge chairs and cabanas.",
        "public_id": "019d7871-1069-7628-a8a7-ff0cdde3967a",
        "storage_key": "property/6767906449167443/019d7871-1069-7628-a8a7-ff0cdde3967a.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style pool, featuring comfortable lounge chairs and private cabanas for the ultimate relaxation experience.",
      "link": "",
      "alt_text": "Resort-style pool with lounge chairs and cabanas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_adbf7a7a-2eca-4ff5-86c3-84aa8d16b366",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-0e7c-75ac-ae63-4e79aaedc299.webp",
      "image_media": {
        "alt_text": "Outdoor common area with grill, fire pit, lounge chairs, and seating areas.",
        "public_id": "019d7871-0e7c-75ac-ae63-4e79aaedc299",
        "storage_key": "property/6767906449167443/019d7871-0e7c-75ac-ae63-4e79aaedc299.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Enjoy the outdoors in our community's common area, featuring a grilling station, fire pit, comfortable lounge chairs, and ample seating for socializing.",
      "link": "",
      "alt_text": "Outdoor common area with grill, fire pit, lounge chairs, and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ac4f25c-5475-4252-a3fc-1db084b09a50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-0b5b-7717-8c81-e283d34a1d83.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex featuring a large swimming pool and lounge area.",
        "public_id": "019d7871-0b5b-7717-8c81-e283d34a1d83",
        "storage_key": "property/6767906449167443/019d7871-0b5b-7717-8c81-e283d34a1d83.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Experience resort-style living at our community, boasting a stunning swimming pool, ample lounge seating, and beautifully landscaped grounds.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex featuring a large swimming pool and lounge area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_068b2f8a-7426-4f75-a289-a7026f26b175",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-0b5b-7717-8c81-e79072e5fa05.webp",
      "image_media": {
        "alt_text": "Aerial view of a luxury apartment complex with a large swimming pool and surrounding lounge area.",
        "public_id": "019d7871-0b5b-7717-8c81-e79072e5fa05",
        "storage_key": "property/6767906449167443/019d7871-0b5b-7717-8c81-e79072e5fa05.webp",
        "width": 1280,
        "height": 719
      },
      "title": "Community",
      "description": "Experience resort-style living with our stunning outdoor swimming pool and ample lounge seating, perfect for relaxation and recreation.",
      "link": "",
      "alt_text": "Aerial view of a luxury apartment complex with a large swimming pool and surrounding lounge area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fead3909-5421-4cb2-b446-fc73d85c687f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7871-01b7-714d-a3bd-a97b156169d9.webp",
      "image_media": {
        "alt_text": "Clean bathroom with a white bathtub, marble tile shower surround, and a hanging bath sponge.",
        "public_id": "019d7871-01b7-714d-a3bd-a97b156169d9",
        "storage_key": "property/6767906449167443/019d7871-01b7-714d-a3bd-a97b156169d9.webp",
        "width": 1136,
        "height": 1703
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed bathroom, featuring a spacious white bathtub and elegant marble tile accents.",
      "link": "",
      "alt_text": "Clean bathroom with a white bathtub, marble tile shower surround, and a hanging bath sponge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dc317b19-5eaf-47df-a0e7-2dbc868220af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-ef86-7620-b7fa-b687adcf5412.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool and spa area with lounge chairs and cabanas.",
        "public_id": "019d7870-ef86-7620-b7fa-b687adcf5412",
        "storage_key": "property/6767906449167443/019d7870-ef86-7620-b7fa-b687adcf5412.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning outdoor swimming pool and spa. Enjoy the sunshine on comfortable lounge chairs or find shade in our private cabanas.",
      "link": "",
      "alt_text": "Luxury swimming pool and spa area with lounge chairs and cabanas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a3610382-21bf-4d9d-86fa-eda5886876b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-f4f7-76d8-ae84-359a9b6805ec.webp",
      "image_media": {
        "alt_text": "Exterior view of Novo at Woodbridge apartment complex with a monument sign.",
        "public_id": "019d7870-f4f7-76d8-ae84-359a9b6805ec",
        "storage_key": "property/6767906449167443/019d7870-f4f7-76d8-ae84-359a9b6805ec.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Discover modern living at Novo at Woodbridge, featuring spacious apartment homes and a vibrant community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of Novo at Woodbridge apartment complex with a monument sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_db1d33f4-c498-45cf-9ec9-e9c247282d95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-ed70-74fd-b91a-fb4d980a206e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, next to the community clubhouse.",
        "public_id": "019d7870-ed70-74fd-b91a-fb4d980a206e",
        "storage_key": "property/6767906449167443/019d7870-ed70-74fd-b91a-fb4d980a206e.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and private cabanas. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, next to the community clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_02ee9387-015e-4d5e-9483-ad82e451e1c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-f037-758d-b2a2-e6e346238ee1.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with white siding and large windows at dusk.",
        "public_id": "019d7870-f037-758d-b2a2-e6e346238ee1",
        "storage_key": "property/6767906449167443/019d7870-f037-758d-b2a2-e6e346238ee1.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring modern architecture, crisp white siding, and large, inviting windows. The building is set against a beautiful twilight sky, creating a welcoming ambiance.",
      "link": "",
      "alt_text": "Modern apartment building exterior with white siding and large windows at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_048503c3-297d-403a-a0a6-01bcb786df77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-eb19-728a-bace-3affc9010d1e.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, and weight racks.",
        "public_id": "019d7870-eb19-728a-bace-3affc9010d1e",
        "storage_key": "property/6767906449167443/019d7870-eb19-728a-bace-3affc9010d1e.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment and free weights for resident use.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, and weight racks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3a4cabf8-fa9e-44dc-bcc1-ca3ce75caa18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-ddff-73ea-97a0-c5314cea6af8.webp",
      "image_media": {
        "alt_text": "Modern coffee machine in apartment community lounge area.",
        "public_id": "019d7870-ddff-73ea-97a0-c5314cea6af8",
        "storage_key": "property/6767906449167443/019d7870-ddff-73ea-97a0-c5314cea6af8.webp",
        "width": 1136,
        "height": 759
      },
      "title": "Community",
      "description": "Enjoy a fresh cup of coffee from our state-of-the-art coffee machine, conveniently located in the community lounge.",
      "link": "",
      "alt_text": "Modern coffee machine in apartment community lounge area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_de9d90fc-8c11-46e4-b2f6-0900afd2d914",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-dcad-70bd-af75-1beeb270351f.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with sofas, armchairs, and ottomans in a well-lit lounge.",
        "public_id": "019d7870-dcad-70bd-af75-1beeb270351f",
        "storage_key": "property/6767906449167443/019d7870-dcad-70bd-af75-1beeb270351f.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish and comfortable resident lounge, featuring ample seating and a welcoming atmosphere.",
      "link": "",
      "alt_text": "Comfortable seating area with sofas, armchairs, and ottomans in a well-lit lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_414b41a7-e618-4e80-b0c2-19b9e233161c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-dc92-704f-b9be-59e7e2b96c72.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with comfortable seating, modern decor, and artwork.",
        "public_id": "019d7870-dc92-704f-b9be-59e7e2b96c72",
        "storage_key": "property/6767906449167443/019d7870-dc92-704f-b9be-59e7e2b96c72.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring plush seating, contemporary art, and a warm ambiance. Perfect for gatherings or quiet moments.",
      "link": "",
      "alt_text": "Spacious community lounge with comfortable seating, modern decor, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fe5c0a03-7a14-49e0-b00c-3e08007c27bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-dec0-759f-9e7d-84d41c00f693.webp",
      "image_media": {
        "alt_text": "Row of treadmills and ellipticals in a well-lit fitness center with large windows.",
        "public_id": "019d7870-dec0-759f-9e7d-84d41c00f693",
        "storage_key": "property/6767906449167443/019d7870-dec0-759f-9e7d-84d41c00f693.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, ellipticals, and other cardio machines.",
      "link": "",
      "alt_text": "Row of treadmills and ellipticals in a well-lit fitness center with large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_add07272-9e0d-4072-b39a-df8fb4b5b28f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-dcab-735c-864b-3625685bed2c.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and marble shower.",
        "public_id": "019d7870-dcab-735c-864b-3625685bed2c",
        "storage_key": "property/6767906449167443/019d7870-dcab-735c-864b-3625685bed2c.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Apartment",
      "description": "Step into this bright and airy bathroom, featuring a spacious vanity with granite countertops, a comfortable toilet, and a sleek marble-tiled shower.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and marble shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_201d40c4-15f3-4469-a71d-fd866149c857",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-dd04-77a4-84fc-30477dae7b9d.webp",
      "image_media": {
        "alt_text": "Communal gathering space with a large wooden table and chairs, a wet bar with a microwave, and large windows overlooking an outdoor patio.",
        "public_id": "019d7870-dd04-77a4-84fc-30477dae7b9d",
        "storage_key": "property/6767906449167443/019d7870-dd04-77a4-84fc-30477dae7b9d.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "Gather with friends or neighbors in this stylish communal space, featuring a large dining table, a convenient wet bar with a microwave, and abundant natural light.",
      "link": "",
      "alt_text": "Communal gathering space with a large wooden table and chairs, a wet bar with a microwave, and large windows overlooking an outdoor patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_468dfaba-6d3c-4ce4-985f-93dc403f45c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-dcf2-734d-9fb4-aff66711b149.webp",
      "image_media": {
        "alt_text": "Lobby seating area with blue chairs, modular sofa, and tables.",
        "public_id": "019d7870-dcf2-734d-9fb4-aff66711b149",
        "storage_key": "property/6767906449167443/019d7870-dcf2-734d-9fb4-aff66711b149.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable lobby seating area, featuring plush seating, modern tables, and tasteful decor.",
      "link": "",
      "alt_text": "Lobby seating area with blue chairs, modular sofa, and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_88408e14-e6ab-40b6-85ed-b039cff35a81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-dc93-7606-93b1-caaa29941cba.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines, weight racks, and a lifting bench.",
        "public_id": "019d7870-dc93-7606-93b1-caaa29941cba",
        "storage_key": "property/6767906449167443/019d7870-dc93-7606-93b1-caaa29941cba.webp",
        "width": 1136,
        "height": 758
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, weightlifting stations, and free weights for residents.",
      "link": "",
      "alt_text": "Gym with cardio machines, weight racks, and a lifting bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a2fe2448-a528-43c2-8e86-7c8e0352e82a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-acc8-7079-ae92-58d204cd37bb.webp",
      "image_media": {
        "alt_text": "Queen-size bed with white and blue bedding in a bedroom with a dresser and two windows.",
        "public_id": "019d7870-acc8-7079-ae92-58d204cd37bb",
        "storage_key": "property/6767906449167443/019d7870-acc8-7079-ae92-58d204cd37bb.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Relax and unwind in this cozy bedroom, featuring a queen-size bed, modern decor, and plenty of natural light.",
      "link": "",
      "alt_text": "Queen-size bed with white and blue bedding in a bedroom with a dresser and two windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_affe4c37-9688-49dc-a9bb-345b25c281f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-a8aa-777e-936b-f3ad1214cb80.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and chair.",
        "public_id": "019d7870-a8aa-777e-936b-f3ad1214cb80",
        "storage_key": "property/6767906449167443/019d7870-a8aa-777e-936b-f3ad1214cb80.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a plush sofa, a warm wooden coffee table, and accent chair, perfect for relaxation.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, and chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6a8b8d6b-43be-45b0-b5df-a220f8ecef6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-aa1e-755b-b7a3-a9fdbd020c57.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, granite countertop, and a toilet.",
        "public_id": "019d7870-aa1e-755b-b7a3-a9fdbd020c57",
        "storage_key": "property/6767906449167443/019d7870-aa1e-755b-b7a3-a9fdbd020c57.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Step into a spa-like bathroom featuring a spacious vanity with ample storage, elegant granite countertops, and a comfortable toilet area. Perfect for relaxing after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, granite countertop, and a toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aac00a56-72d8-441d-af4a-db5532d91b0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-ab32-72e9-9eea-00d1f5377f15.webp",
      "image_media": {
        "alt_text": "Empty closet with wire shelving",
        "public_id": "019d7870-ab32-72e9-9eea-00d1f5377f15",
        "storage_key": "property/6767906449167443/019d7870-ab32-72e9-9eea-00d1f5377f15.webp",
        "width": 854,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with built-in wire shelving for ample storage.",
      "link": "",
      "alt_text": "Empty closet with wire shelving",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cbc9cb7b-a78e-43c8-b5b1-7ac3a9ff45c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-a89f-761c-9aeb-19f582f0858d.webp",
      "image_media": {
        "alt_text": "Bright living room with a sofa, coffee table, dining table, and chairs, featuring a ceiling fan and access to a balcony.",
        "public_id": "019d7870-a89f-761c-9aeb-19f582f0858d",
        "storage_key": "property/6767906449167443/019d7870-a89f-761c-9aeb-19f582f0858d.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Step into this inviting living space, perfect for relaxation and entertaining. Enjoy the bright atmosphere, comfortable seating, and modern dining area.",
      "link": "",
      "alt_text": "Bright living room with a sofa, coffee table, dining table, and chairs, featuring a ceiling fan and access to a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b17612b-f45b-4db2-b72c-991f64c40bec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-a586-706c-b657-25f2dfd38444.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019d7870-a586-706c-b657-25f2dfd38444",
        "storage_key": "property/6767906449167443/019d7870-a586-706c-b657-25f2dfd38444.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "This stunning kitchen features sleek white cabinetry, a stainless steel microwave and oven, and elegant granite countertops, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e318af51-3873-4af8-ae96-641d23b3d9b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-a394-74af-9a02-13405f0cae60.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator and oven in a modern kitchen with white cabinets and granite countertops.",
        "public_id": "019d7870-a394-74af-9a02-13405f0cae60",
        "storage_key": "property/6767906449167443/019d7870-a394-74af-9a02-13405f0cae60.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "A bright and modern kitchen featuring stainless steel appliances, white cabinetry, and granite countertops. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Stainless steel refrigerator and oven in a modern kitchen with white cabinets and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1c8c54f5-be20-453c-b111-355f937566da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-9fa0-710f-ad08-a8cf4c4ce9ee.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, granite countertops, and island with seating.",
        "public_id": "019d7870-9fa0-710f-ad08-a8cf4c4ce9ee",
        "storage_key": "property/6767906449167443/019d7870-9fa0-710f-ad08-a8cf4c4ce9ee.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Beautifully appointed kitchen featuring stainless steel appliances, ample cabinet storage, and granite countertops. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, granite countertops, and island with seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c6a32c22-f209-412c-b3fc-0af739746475",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-9b0b-7544-b77b-87ea579379e6.webp",
      "image_media": {
        "alt_text": "Swimming pool with fountains and lounge chairs",
        "public_id": "019d7870-9b0b-7544-b77b-87ea579379e6",
        "storage_key": "property/6767906449167443/019d7870-9b0b-7544-b77b-87ea579379e6.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with soothing fountains and comfortable lounge chairs.",
      "link": "",
      "alt_text": "Swimming pool with fountains and lounge chairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a8269ccd-795c-46fc-a1f7-695260fe5a83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-9c9a-7649-86e9-f903b4c0c3f7.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with a laundry room mat.",
        "public_id": "019d7870-9c9a-7649-86e9-f903b4c0c3f7",
        "storage_key": "property/6767906449167443/019d7870-9c9a-7649-86e9-f903b4c0c3f7.webp",
        "width": 854,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for easy laundry days. Make laundry less of a chore with this essential apartment amenity.",
      "link": "",
      "alt_text": "In-unit washer and dryer with a laundry room mat.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3151ba5a-b57f-4ed0-bb2c-537a17179222",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-9afc-778e-ba54-da0cef862152.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and open-concept living area.",
        "public_id": "019d7870-9afc-778e-ba54-da0cef862152",
        "storage_key": "property/6767906449167443/019d7870-9afc-778e-ba54-da0cef862152.webp",
        "width": 1280,
        "height": 852
      },
      "title": "Apartment",
      "description": "Enjoy a spacious and modern open-concept living area with a sleek kitchen, perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Modern kitchen with island and open-concept living area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e0bd1901-779f-4783-b5d7-0666ddba1401",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-9ae4-731e-919f-c425b7627cab.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019d7870-9ae4-731e-919f-c425b7627cab",
        "storage_key": "property/6767906449167443/019d7870-9ae4-731e-919f-c425b7627cab.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge chairs and shaded areas for ultimate relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f578769a-6028-4dfc-a45b-414dae063cc0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-9898-75ff-bb2c-b155f8e6bde6.webp",
      "image_media": {
        "alt_text": "Outdoor lounging area with cabanas and lounge chairs.",
        "public_id": "019d7870-9898-75ff-bb2c-b155f8e6bde6",
        "storage_key": "property/6767906449167443/019d7870-9898-75ff-bb2c-b155f8e6bde6.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge area, featuring comfortable cabanas and plush lounge chairs perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor lounging area with cabanas and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5a2748fd-5040-4858-b232-b4660251cabb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-9848-745c-b5c6-e8f80ea073b8.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with fountains and lounge chairs",
        "public_id": "019d7870-9848-745c-b5c6-e8f80ea073b8",
        "storage_key": "property/6767906449167443/019d7870-9848-745c-b5c6-e8f80ea073b8.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Relax by the resort-style pool, featuring fountains and ample lounge seating. Perfect for a sunny afternoon.",
      "link": "",
      "alt_text": "Outdoor swimming pool with fountains and lounge chairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3663a8d5-7f83-4df6-92c6-803d820a7943",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-9418-74cb-a63a-3daaa4dbdba9.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with seating and a table, overlooking the pool.",
        "public_id": "019d7870-9418-74cb-a63a-3daaa4dbdba9",
        "storage_key": "property/6767906449167443/019d7870-9418-74cb-a63a-3daaa4dbdba9.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge area, complete with comfortable seating, a table, and a view of the sparkling pool.",
      "link": "",
      "alt_text": "Outdoor lounge area with seating and a table, overlooking the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7bb0bd6f-7a3a-4d88-8954-f87a4e9cef94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-8fc2-71b9-8efe-e9b0e800bbe7.webp",
      "image_media": {
        "alt_text": "Ping pong table and seating area outside apartment buildings with a pool in the background.",
        "public_id": "019d7870-8fc2-71b9-8efe-e9b0e800bbe7",
        "storage_key": "property/6767906449167443/019d7870-8fc2-71b9-8efe-e9b0e800bbe7.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation and relaxation with a ping pong table and comfortable seating areas, perfect for socializing and unwinding.",
      "link": "",
      "alt_text": "Ping pong table and seating area outside apartment buildings with a pool in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d5f719e2-ec50-4c65-b9c7-0579752b3174",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-8e76-7228-b174-44de9116bc2b.webp",
      "image_media": {
        "alt_text": "Modern lounge area with comfortable seating and decorative art.",
        "public_id": "019d7870-8e76-7228-b174-44de9116bc2b",
        "storage_key": "property/6767906449167443/019d7870-8e76-7228-b174-44de9116bc2b.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring plush seating and elegant decor. Perfect for socializing or quiet reflection.",
      "link": "",
      "alt_text": "Modern lounge area with comfortable seating and decorative art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5b42d6af-4e9f-4521-b00a-d411ce9f9b22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-8e57-75c2-b533-f4bedc436e28.webp",
      "image_media": {
        "alt_text": "Community kitchen area with a large wooden table and bar stools.",
        "public_id": "019d7870-8e57-75c2-b533-f4bedc436e28",
        "storage_key": "property/6767906449167443/019d7870-8e57-75c2-b533-f4bedc436e28.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "A modern community kitchen space featuring a large live-edge wooden table, comfortable bar stools, and a well-equipped kitchenette area.",
      "link": "",
      "alt_text": "Community kitchen area with a large wooden table and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1bf6d9b8-7576-4186-a771-baffa90fc0c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-8e66-707c-804e-1368d9107cc3.webp",
      "image_media": {
        "alt_text": "Covered outdoor patio with ping pong table, seating, and view of apartment buildings.",
        "public_id": "019d7870-8e66-707c-804e-1368d9107cc3",
        "storage_key": "property/6767906449167443/019d7870-8e66-707c-804e-1368d9107cc3.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation and relaxation on the covered patio, complete with a ping pong table, comfortable seating, and scenic views of the community buildings.",
      "link": "",
      "alt_text": "Covered outdoor patio with ping pong table, seating, and view of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_71e39687-b3d5-41ed-99a1-dcdb46710257",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-8e16-746a-bd28-f839afa83b41.webp",
      "image_media": {
        "alt_text": "Community kitchen area with a large wooden table, high chairs, and a stainless steel refrigerator.",
        "public_id": "019d7870-8e16-746a-bd28-f839afa83b41",
        "storage_key": "property/6767906449167443/019d7870-8e16-746a-bd28-f839afa83b41.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Enjoy the community kitchen, perfect for gatherings or casual meals. Fully equipped with a refrigerator and ample seating.",
      "link": "",
      "alt_text": "Community kitchen area with a large wooden table, high chairs, and a stainless steel refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_74f5e5d4-49e7-45c4-b27b-f5e464fe7dbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-8e90-7730-9d96-b676b7e115f5.webp",
      "image_media": {
        "alt_text": "Clubhouse lounge area with modern furniture, sofas, chairs, and a coffee table.",
        "public_id": "019d7870-8e90-7730-9d96-b676b7e115f5",
        "storage_key": "property/6767906449167443/019d7870-8e90-7730-9d96-b676b7e115f5.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed clubhouse lounge, featuring comfortable seating and a welcoming atmosphere.",
      "link": "",
      "alt_text": "Clubhouse lounge area with modern furniture, sofas, chairs, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_13b28fe0-f3ea-4438-93ac-1c032bc07b83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-875d-7737-b99a-0f47b02331a4.webp",
      "image_media": {
        "alt_text": "Well-equipped gym with cardio machines, weight racks, and benches.",
        "public_id": "019d7870-875d-7737-b99a-0f47b02331a4",
        "storage_key": "property/6767906449167443/019d7870-875d-7737-b99a-0f47b02331a4.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a full range of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Well-equipped gym with cardio machines, weight racks, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_573d43bd-31b4-4b36-8e03-1c69eea9314d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-85d4-7117-a8c3-cf8a3b1dc133.webp",
      "image_media": {
        "alt_text": "Fitness center with rowing machine, weights, and cardio equipment.",
        "public_id": "019d7870-85d4-7117-a8c3-cf8a3b1dc133",
        "storage_key": "property/6767906449167443/019d7870-85d4-7117-a8c3-cf8a3b1dc133.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of cardio and weight training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with rowing machine, weights, and cardio equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f3502ffa-8e8a-40af-956b-26ef52c6ee04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-8387-73de-854a-ab722b2e8152.webp",
      "image_media": {
        "alt_text": "Spacious gym with a rowing machine, weight rack with dumbbells, and a weight bench.",
        "public_id": "019d7870-8387-73de-854a-ab722b2e8152",
        "storage_key": "property/6767906449167443/019d7870-8387-73de-854a-ab722b2e8152.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with everything you need for a great workout, including cardio machines, free weights, and a weight bench.",
      "link": "",
      "alt_text": "Spacious gym with a rowing machine, weight rack with dumbbells, and a weight bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_97b26852-5f09-44ea-ba6b-0282daaece30",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-7fe5-7579-87d2-1a71555cd838.webp",
      "image_media": {
        "alt_text": "Modern gym with weight racks, squat rack, medicine balls, and cardio machines.",
        "public_id": "019d7870-7fe5-7579-87d2-1a71555cd838",
        "storage_key": "property/6767906449167443/019d7870-7fe5-7579-87d2-1a71555cd838.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a variety of weight training equipment and cardio machines, perfect for your workout needs.",
      "link": "",
      "alt_text": "Modern gym with weight racks, squat rack, medicine balls, and cardio machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7903fb7c-9d90-4a86-a388-b9da95f43a27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-7fdf-7651-ae36-9d1793735569.webp",
      "image_media": {
        "alt_text": "Row of treadmills and elliptical machines in a fitness center",
        "public_id": "019d7870-7fdf-7651-ae36-9d1793735569",
        "storage_key": "property/6767906449167443/019d7870-7fdf-7651-ae36-9d1793735569.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Modern fitness center with cardio equipment and large windows overlooking the grounds.",
      "link": "",
      "alt_text": "Row of treadmills and elliptical machines in a fitness center",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_65d5015b-fd4a-4a0b-818a-1f6512055242",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-7fd8-77ff-89b4-7ad008dfde67.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with a clubhouse and parking lot.",
        "public_id": "019d7870-7fd8-77ff-89b4-7ad008dfde67",
        "storage_key": "property/6767906449167443/019d7870-7fd8-77ff-89b4-7ad008dfde67.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Charming exterior of the clubhouse and apartment buildings, with a well-maintained parking lot and landscaping.",
      "link": "",
      "alt_text": "Exterior of a modern apartment building with a clubhouse and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_44128188-302a-49e2-a870-f73a8aacd4ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-7e3a-728c-9d70-ad5541418b25.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with white siding and dark roofs at dusk.",
        "public_id": "019d7870-7e3a-728c-9d70-ad5541418b25",
        "storage_key": "property/6767906449167443/019d7870-7e3a-728c-9d70-ad5541418b25.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Discover your new home in this stunning apartment community, featuring modern architecture and beautiful evening skies.",
      "link": "",
      "alt_text": "Exterior of a modern apartment building with white siding and dark roofs at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8b66e86b-d8bb-4a7e-809e-aa3f54bf0bf1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-7c10-7762-9551-463b1e6fbf6c.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, stair climber, and weight rack.",
        "public_id": "019d7870-7c10-7762-9551-463b1e6fbf6c",
        "storage_key": "property/6767906449167443/019d7870-7c10-7762-9551-463b1e6fbf6c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, free weights, and functional training equipment for residents.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, stair climber, and weight rack.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_65a312d7-d1f8-43cc-966d-c83bac1c722b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-7b79-753a-a209-617b1164a69e.webp",
      "image_media": {
        "alt_text": "Exterior of a modern white apartment building with large windows and a welcoming entrance.",
        "public_id": "019d7870-7b79-753a-a209-617b1164a69e",
        "storage_key": "property/6767906449167443/019d7870-7b79-753a-a209-617b1164a69e.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Discover the inviting exterior of our apartment community, featuring modern architecture and a well-maintained facade. Welcome home!",
      "link": "",
      "alt_text": "Exterior of a modern white apartment building with large windows and a welcoming entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e747d668-b770-4135-b0d7-a5c175261478",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-7cf0-7374-ab44-55c60a98d4cf.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with parking lot at dusk.",
        "public_id": "019d7870-7cf0-7374-ab44-55c60a98d4cf",
        "storage_key": "property/6767906449167443/019d7870-7cf0-7374-ab44-55c60a98d4cf.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Welcome to our beautiful apartment community, featuring a modern exterior and convenient parking, perfect for a comfortable and stylish living experience.",
      "link": "",
      "alt_text": "Modern apartment building exterior with parking lot at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ed67d07-12d7-42d3-88d7-c032ff5e6af1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-7772-706e-aadf-c9b89cef2306.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with treadmills, ellipticals, and weight racks.",
        "public_id": "019d7870-7772-706e-aadf-c9b89cef2306",
        "storage_key": "property/6767906449167443/019d7870-7772-706e-aadf-c9b89cef2306.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center offers a variety of cardio and strength training equipment for your workout needs.",
      "link": "",
      "alt_text": "Well-equipped fitness center with treadmills, ellipticals, and weight racks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fd5bc12f-9ad5-4d24-89f0-00451a73cd75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-769f-760e-870a-4f0e4fca4aa8.webp",
      "image_media": {
        "alt_text": "Clubhouse entrance at dusk with a blue sky.",
        "public_id": "019d7870-769f-760e-870a-4f0e4fca4aa8",
        "storage_key": "property/6767906449167443/019d7870-769f-760e-870a-4f0e4fca4aa8.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Welcome to the clubhouse, the heart of our community. This building offers residents access to amenities and serves as a central gathering place.",
      "link": "",
      "alt_text": "Clubhouse entrance at dusk with a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_35c9f9ce-545c-4949-b935-1583a25a1dd3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-6fc0-739d-8626-0cdd7d4a038a.webp",
      "image_media": {
        "alt_text": "Building exterior with accessible parking in foreground",
        "public_id": "019d7870-6fc0-739d-8626-0cdd7d4a038a",
        "storage_key": "property/6767906449167443/019d7870-6fc0-739d-8626-0cdd7d4a038a.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Modern apartment building exterior with accessible parking in the foreground and manicured landscaping.",
      "link": "",
      "alt_text": "Building exterior with accessible parking in foreground",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_59466e18-de56-4e70-92f8-51e05f69cfa6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d7870-6f3c-7728-9ffb-50ca37799751.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with multiple stories, balconies, and dark grey and white siding.",
        "public_id": "019d7870-6f3c-7728-9ffb-50ca37799751",
        "storage_key": "property/6767906449167443/019d7870-6f3c-7728-9ffb-50ca37799751.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "View of the exterior of a modern apartment building showcasing its multi-story design with balconies and a combination of dark grey and white siding.",
      "link": "",
      "alt_text": "Exterior of a modern apartment building with multiple stories, balconies, and dark grey and white siding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_17d5ae4b-9392-419c-aded-a6cc0255cb82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "3867 GA-138, Stockbridge, GA 30281, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of fresh and prepared dishes, including pot roast, omelets, and seafood. They also highlight the reasonable prices, friendly atmosphere, and attentive service.\n\nSome reviews mention the restaurant can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-3d28-75af-8e1a-0e39453bb9cb.webp",
      "poi_featured_image_media": {
        "alt_text": "Golden Corral restaurant exterior at dusk with illuminated sign and cars in the parking lot.",
        "public_id": "019d72d0-3d28-75af-8e1a-0e39453bb9cb",
        "storage_key": "property/6767906449167443/019d72d0-3d28-75af-8e1a-0e39453bb9cb.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/location-detail/2656/golden-corral-highway-138-se/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=2656",
      "poi_directions_map_url": "https://maps.google.com/?cid=8964673729521400165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "33.5544832",
      "poi_longitude": "-84.2647061",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-389-4830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-052e-7375-b347-0509471c5bbc.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d72d1-052e-7375-b347-0509471c5bbc",
        "storage_key": "property/6767906449167443/019d72d1-052e-7375-b347-0509471c5bbc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwRJyrFQtwYkRZTlml0LraHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_0dce583c-c3fc-4b49-9332-8bf04446607b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2042 Mt Zion Rd, Morrow, GA 30260, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant offers a variety of chicken sandwiches and unique menu items, such as peach waffles with strawberries and fried okra. They highlight the diner-style atmosphere and the friendly staff. They also like the fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-5192-72ad-baf4-68f0f8f6e663.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Truett's Grill restaurant with a drive-thru lane and a large sign.",
        "public_id": "019d72d0-5192-72ad-baf4-68f0f8f6e663",
        "storage_key": "property/6767906449167443/019d72d0-5192-72ad-baf4-68f0f8f6e663.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ga/truetts-grill-morrow?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3502557622338064344&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "33.5625775",
      "poi_longitude": "-84.32314199999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-210-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-052e-7375-b347-0509471c5bbc.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d72d1-052e-7375-b347-0509471c5bbc",
        "storage_key": "property/6767906449167443/019d72d1-052e-7375-b347-0509471c5bbc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWwlLLjv59IgR2A_MpJmVmzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_7b636578-9f52-4d5e-a4aa-0a679ec7108e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "1458 Southlake Plaza Dr, Morrow, GA 30260, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "People say this American restaurant serves delicious pancakes, bacon, and mimosas. They also highlight the friendly staff, pleasant environment, and reasonable prices.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-3f8a-73bd-ac22-f44751b67c41.webp",
      "poi_featured_image_media": {
        "alt_text": "Cracker Barrel Old Country Store entrance with rocking chairs and flowers.",
        "public_id": "019d72d0-3f8a-73bd-ac22-f44751b67c41",
        "storage_key": "property/6767906449167443/019d72d0-3f8a-73bd-ac22-f44751b67c41.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/ga/morrow/38/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=17700888406090428338&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "33.5789314",
      "poi_longitude": "-84.342648",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-961-4533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-052e-7375-b347-0509471c5bbc.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019d72d1-052e-7375-b347-0509471c5bbc",
        "storage_key": "property/6767906449167443/019d72d1-052e-7375-b347-0509471c5bbc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoZVvSq3-9IgRsq_Z1TgwpvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_00e9a657-d37c-4b30-81cb-a8f1bb36b132",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "SUDO BAR & GRILL (ELLENWOOD)",
      "poi_type": "Restaurants",
      "poi_address": "1792 Panola Rd, Ellenwood, GA 30294, USA",
      "poi_short_description": "Laid-back bar eatery serving burgers and wings, plus cocktails and hookah, along with karaoke.",
      "poi_long_description": "People say this restaurant serves up delicious salmon bites, wings, and strong drinks. They also highlight the friendly staff, great service, and lively atmosphere with DJs and karaoke.\n\nSome reviews mention the drinks can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-4046-7385-9a1c-697f08944269.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a modern bar with neon purple lighting, multiple TVs, and seating areas.",
        "public_id": "019d72d0-4046-7385-9a1c-697f08944269",
        "storage_key": "property/6767906449167443/019d72d0-4046-7385-9a1c-697f08944269.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://sudobarandgrill.com/ellenwood?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=15603470915804163089&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sudo-bar--grill-ellenwood",
      "poi_latitude": "33.6222396",
      "poi_longitude": "-84.2359817",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 678-343-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-0340-720a-a444-d9fe13872e5c.webp",
      "poi_map_icon_media": {
        "alt_text": "Martini glass icon",
        "public_id": "019d72d1-0340-720a-a444-d9fe13872e5c",
        "storage_key": "property/6767906449167443/019d72d1-0340-720a-a444-d9fe13872e5c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg5MN2JJV9IgREWyljyCqitg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_5d0f7985-5ed1-4d30-a91b-9eef8353855c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Southlake Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "1000 Southlake Cir, Morrow, GA 30260, USA",
      "poi_short_description": "A collection of retailers anchored by department stores, plus a food court with a carousel.",
      "poi_long_description": "People say this shopping center offers a variety of stores, including shoe stores, clothing stores, and jewelry stores, as well as a food court with several options. They also highlight the convenient location, clean and quiet atmosphere, and friendly customer service.\n\nOther reviews mention the air conditioning can be out.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-513a-728c-89f8-2de1e92efc62.webp",
      "poi_featured_image_media": {
        "alt_text": "Father and daughter walking towards Southlake Mall entrance",
        "public_id": "019d72d0-513a-728c-89f8-2de1e92efc62",
        "storage_key": "property/6767906449167443/019d72d0-513a-728c-89f8-2de1e92efc62.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.southlakemall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1088496944064000029&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southlake-mall",
      "poi_latitude": "33.5749881",
      "poi_longitude": "-84.3513953",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-961-1050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-0528-7078-bc5d-2ecfd420af01.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d72d1-0528-7078-bc5d-2ecfd420af01",
        "storage_key": "property/6767906449167443/019d72d1-0528-7078-bc5d-2ecfd420af01.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJqxD5q1X59IgRHXAIGjQeGw8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1a11ff7d-f590-4fb5-9ebc-140517288fb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Nam Dae Mun Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1940 Mt Zion Rd, Morrow, GA 30260, USA",
      "poi_short_description": "Vast farmer's market focusing on global food products including produce, meat & seafood.",
      "poi_long_description": "People say this supermarket offers a wide variety of fresh fruits, vegetables, seafood, and international foods, as well as a bakery and spices. They also highlight the reasonable prices, clean and well-stocked shelves, and friendly, helpful staff.\n\nSome reviews mention there can be long lines.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-3f8d-7656-8fde-169790465290.webp",
      "poi_featured_image_media": {
        "alt_text": "Nam Dae Mun Farmers Market building exterior with a parking lot and several cars.",
        "public_id": "019d72d0-3f8d-7656-8fde-169790465290",
        "storage_key": "property/6767906449167443/019d72d0-3f8d-7656-8fde-169790465290.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.ndmmarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6443480913890502884&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nam-dae-mun-farmers-market",
      "poi_latitude": "33.5668525",
      "poi_longitude": "-84.3258132",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-251-1555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-033a-70fb-821e-b9b428085f58.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d72d1-033a-70fb-821e-b9b428085f58",
        "storage_key": "property/6767906449167443/019d72d1-033a-70fb-821e-b9b428085f58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd8CQkDD59IgR5OhzjcDXa1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_d5bb7c1a-f25b-4ef0-ba0b-377fba9b5ab3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2034 Mt Zion Rd, Morrow, GA 30260, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers an excellent selection of plants and gardening supplies, as well as light bulbs, wood, and appliances. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-3cb6-7043-a92f-fae1dc65b5db.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of The Home Depot store with an American flag.",
        "public_id": "019d72d0-3cb6-7043-a92f-fae1dc65b5db",
        "storage_key": "property/6767906449167443/019d72d0-3cb6-7043-a92f-fae1dc65b5db.webp",
        "width": 1256,
        "height": 786
      },
      "poi_business_url": "https://www.homedepot.com/l/Morrow/GA/Morrow/30260/114?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5361682806427823992&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.5640941",
      "poi_longitude": "-84.3223172",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-478-9990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-0528-7078-bc5d-2ecfd420af01.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d72d1-0528-7078-bc5d-2ecfd420af01",
        "storage_key": "property/6767906449167443/019d72d1-0528-7078-bc5d-2ecfd420af01.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJG24RLzv59IgReC9z4xqGaEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_52dd82bc-43ee-445f-ab83-810a609e0214",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Publix Super Market at Mt. Zion",
      "poi_type": "Shopping & Retail",
      "poi_address": "2035 Mt Zion Rd, Morrow, GA 30260, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this supermarket offers a great selection of subs, deli items, and fresh produce. They also highlight the clean and comfortable shopping experience, and the friendly and mannerable staff.\n\nSome reviews mention the deli service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-3ffa-7451-b2d5-bbc94bfdcd2c.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Publix grocery store and adjacent businesses in a strip mall at dusk, with a parking lot in the foreground.",
        "public_id": "019d72d0-3ffa-7451-b2d5-bbc94bfdcd2c",
        "storage_key": "property/6767906449167443/019d72d0-3ffa-7451-b2d5-bbc94bfdcd2c.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=461&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=16291753049725510231&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "publix-super-market-at-mt-zion",
      "poi_latitude": "33.5616957",
      "poi_longitude": "-84.3251349",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-472-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-033a-70fb-821e-b9b428085f58.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d72d1-033a-70fb-821e-b9b428085f58",
        "storage_key": "property/6767906449167443/019d72d1-033a-70fb-821e-b9b428085f58.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAYU2wP379IgRV6JG0RTvF-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_1ed86fd3-48cd-4aee-8f51-e38b69d28419",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Clayton State University",
      "poi_type": "Education",
      "poi_address": "2000 Clayton State Blvd, Morrow, GA 30260, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-6c82-7387-81a8-d51452ae350e.webp",
      "poi_featured_image_media": {
        "alt_text": "Clayton State University monument sign with trees and landscaping.",
        "public_id": "019d72d0-6c82-7387-81a8-d51452ae350e",
        "storage_key": "property/6767906449167443/019d72d0-6c82-7387-81a8-d51452ae350e.webp",
        "width": 1200,
        "height": 572
      },
      "poi_business_url": "https://www.clayton.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1480539289079976038&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clayton-state-university",
      "poi_latitude": "33.5949194",
      "poi_longitude": "-84.32953909999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 678-466-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-04c3-7280-bbf7-156f97d8fde0.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d72d1-04c3-7280-bbf7-156f97d8fde0",
        "storage_key": "property/6767906449167443/019d72d1-04c3-7280-bbf7-156f97d8fde0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf6Gb0tz-9IgRZhCfoaPuixQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1f509e5e-fcc3-4fcc-8a37-b64e14201bf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Lake Harbin KinderCare",
      "poi_type": "Education",
      "poi_address": "2048 Lake Harbin Rd, Morrow, GA 30260, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-6b53-759d-a97a-9c2c389e922a.webp",
      "poi_featured_image_media": {
        "alt_text": "Classroom with tables, chairs, toys, and children's artwork displayed on walls.",
        "public_id": "019d72d0-6b53-759d-a97a-9c2c389e922a",
        "storage_key": "property/6767906449167443/019d72d0-6b53-759d-a97a-9c2c389e922a.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/morrow/ga/300410?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA3MjM1LTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=3216664429105909822&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lake-harbin-kindercare",
      "poi_latitude": "33.58165049999999",
      "poi_longitude": "-84.32331549999999",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-961-0290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-04c3-7280-bbf7-156f97d8fde0.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d72d1-04c3-7280-bbf7-156f97d8fde0",
        "storage_key": "property/6767906449167443/019d72d1-04c3-7280-bbf7-156f97d8fde0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxTgn8s3-9IgRPhB-ckHjoyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_25cc3b93-ec20-4023-977f-a78bdad6d097",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Spivey Splash Water Park",
      "poi_type": "Entertainment",
      "poi_address": "2300 Hwy 138 SE, Jonesboro, GA 30236, USA",
      "poi_short_description": "Relaxed space offering water slides, a lazy river and a kiddie pool.",
      "poi_long_description": "Visitors say this water park offers a lazy river, water slides, a kiddie pool, and a wave pool, with food and drinks available for purchase. They like that it's a fun, affordable place for families with kids to cool off on a hot day, and the lifeguards are attentive.\n\nSome reviews mention the park can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-7002-7682-9bef-1974e3a7113c.webp",
      "poi_featured_image_media": {
        "alt_text": "Water park with multiple slides and a pool with people enjoying the water.",
        "public_id": "019d72d0-7002-7682-9bef-1974e3a7113c",
        "storage_key": "property/6767906449167443/019d72d0-7002-7682-9bef-1974e3a7113c.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.spiveysplash.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10197488550364441821&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "spivey-splash-water-park",
      "poi_latitude": "33.5243589",
      "poi_longitude": "-84.3108235",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-603-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d72d1-047e-716f-af8f-5e1c0d768d9b",
        "storage_key": "property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQ3dxwn59IgR3eyV1c7BhI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_08be61e9-1d93-4a61-9459-b83a7e969bfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Tara Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1055 Battle Creek Rd, Jonesboro, GA 30236, USA",
      "poi_short_description": "Venue for football games and other high-school sporting events, plus a track.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-6f27-75f8-807b-6fded41c2d49.webp",
      "poi_featured_image_media": {
        "alt_text": "Aerial view of a football stadium with a track and bleachers.",
        "public_id": "019d72d0-6f27-75f8-807b-6fded41c2d49",
        "storage_key": "property/6767906449167443/019d72d0-6f27-75f8-807b-6fded41c2d49.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "https://stadiumconnection.com/ga/stadium.php?id=4158",
      "poi_directions_map_url": "https://maps.google.com/?cid=12398779952835159341&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tara-stadium",
      "poi_latitude": "33.5506763",
      "poi_longitude": "-84.35742619999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-473-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-0334-70dc-bd74-fb36129051ee.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic graphic illustration",
        "public_id": "019d72d1-0334-70dc-bd74-fb36129051ee",
        "storage_key": "property/6767906449167443/019d72d1-0334-70dc-bd74-fb36129051ee.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG-WbK9n79IgRLWX58KxQEaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_f0d4a679-61cf-4b8d-a3f7-bb218abbbe3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Steele rd stadium",
      "poi_type": "Entertainment",
      "poi_address": "Steele Rd, Ellenwood, GA 30294, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-6ec9-7620-a595-d02c6f4b5053.webp",
      "poi_featured_image_media": {
        "alt_text": "Aerial view of a football stadium and surrounding school buildings.",
        "public_id": "019d72d0-6ec9-7620-a595-d02c6f4b5053",
        "storage_key": "property/6767906449167443/019d72d0-6ec9-7620-a595-d02c6f4b5053.webp",
        "width": 450,
        "height": 300
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15385259367031508322&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "steele-rd-stadium",
      "poi_latitude": "33.6188434",
      "poi_longitude": "-84.26412119999999",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-0334-70dc-bd74-fb36129051ee.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic graphic illustration",
        "public_id": "019d72d1-0334-70dc-bd74-fb36129051ee",
        "storage_key": "property/6767906449167443/019d72d1-0334-70dc-bd74-fb36129051ee.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx_oOcgBV9IgRYg0qNeFrg9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_ef647cd2-dfaa-4daa-8490-4599cc52cca7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Road To Tara Museum",
      "poi_type": "Entertainment",
      "poi_address": "Historic Train Depot, 104 N Main St, Jonesboro, GA 30236, USA",
      "poi_short_description": "Unique collection of Gone With The Wind manuscripts, costumes & Civil War history exhibits.",
      "poi_long_description": "People say this museum offers a beautiful collection of Gone With The Wind artifacts and behind-the-scenes information. They highlight the great value and charming, historical vibe. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-7053-749f-9df9-1774b2ca51ea.webp",
      "poi_featured_image_media": {
        "alt_text": "Mannequin wearing a vintage green and white dress with ruffled sleeves and a gold necklace.",
        "public_id": "019d72d0-7053-749f-9df9-1774b2ca51ea",
        "storage_key": "property/6767906449167443/019d72d0-7053-749f-9df9-1774b2ca51ea.webp",
        "width": 2048,
        "height": 1371
      },
      "poi_business_url": "https://seeclaytoncountyga.com/things-to-do/attraction/road-to-tara-museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12845118109046884667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "road-to-tara-museum",
      "poi_latitude": "33.5218294",
      "poi_longitude": "-84.3543753",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-478-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-04c7-735d-ae7b-40d09e777f61.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with the letter M inside.",
        "public_id": "019d72d1-04c7-735d-ae7b-40d09e777f61",
        "storage_key": "property/6767906449167443/019d72d1-04c7-735d-ae7b-40d09e777f61.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJc2oPKSj69IgRO0mtI90GQ7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a2878fe3-de9a-4402-9cfb-5926ae4e4e24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Stately Oaks",
      "poi_type": "Entertainment",
      "poi_address": "100 Carriage Ln, Jonesboro, GA 30236, USA",
      "poi_short_description": "Recreated, 24, 25] plantation for a cotton farmer, with a kitchen and a one-room schoolhouse.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-7ce0-7650-8cd1-455378d479c0.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a large, white, multi-story house with a wraparound porch and manicured landscaping.",
        "public_id": "019d72d0-7ce0-7650-8cd1-455378d479c0",
        "storage_key": "property/6767906449167443/019d72d0-7ce0-7650-8cd1-455378d479c0.webp",
        "width": 1147,
        "height": 616
      },
      "poi_business_url": "http://historicaljonesboroga.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11302816891314171349&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stately-oaks",
      "poi_latitude": "33.5153865",
      "poi_longitude": "-84.3503033",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-473-0197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-04c7-735d-ae7b-40d09e777f61.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon with the letter M inside.",
        "public_id": "019d72d1-04c7-735d-ae7b-40d09e777f61",
        "storage_key": "property/6767906449167443/019d72d1-04c7-735d-ae7b-40d09e777f61.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLwulv4v59IgR1e0Q6BOs25w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1fe2955e-51c8-4102-b798-916c51e50703",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Fitness Connection",
      "poi_type": "Health and Wellness",
      "poi_address": "1905 Mt Zion Rd Suite B, Morrow, GA 30260, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of cardio machines, free weights, and group fitness classes, as well as amenities like a sauna and a women's-only workout area. They highlight the spacious layout, clean facilities, and affordable membership options. They also like the friendly, welcoming, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-8088-7071-ad2e-5578382be2a7.webp",
      "poi_featured_image_media": {
        "alt_text": "Spacious gym with rows of weight machines and cardio equipment.",
        "public_id": "019d72d0-8088-7071-ad2e-5578382be2a7",
        "storage_key": "property/6767906449167443/019d72d0-8088-7071-ad2e-5578382be2a7.webp",
        "width": 3072,
        "height": 2044
      },
      "poi_business_url": "https://fitnessconnection.com/gyms/morrow/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9931930645462137938&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitness-connection",
      "poi_latitude": "33.5657583",
      "poi_longitude": "-84.3316079",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-588-0404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d72d1-047e-716f-af8f-5e1c0d768d9b",
        "storage_key": "property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5ViiOwD59IgRUjyW6ExO1Yk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c4a8aa35-04c1-4732-918c-bb728895f111",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7057 Mt Zion Cir, Morrow, GA 30260, USA",
      "poi_short_description": "Chain health club offering state-of-the-art equipment, pools, and group classes, plus basketball.",
      "poi_long_description": "People say this gym offers a variety of weight lifting machines and the staff is friendly.\n\nOther reviews mention the equipment can be outdated and the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-7ffe-724c-a2a3-e49788cde23c.webp",
      "poi_featured_image_media": {
        "alt_text": "Well-equipped fitness center with weight machines and free weights.",
        "public_id": "019d72d0-7ffe-724c-a2a3-e49788cde23c",
        "storage_key": "property/6767906449167443/019d72d0-7ffe-724c-a2a3-e49788cde23c.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=120&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5388729900729817381&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.5649781",
      "poi_longitude": "-84.3297997",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-960-0393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d72d1-047e-716f-af8f-5e1c0d768d9b",
        "storage_key": "property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFynk0Tv59IgRJdmGQ0udyEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0a4f49fb-5dc0-4096-ba68-a1dfa3f36cfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1964 Mt Zion Rd Ste 204, Morrow, GA 30260, USA",
      "poi_short_description": "Chain fitness center at the Shoppes at Morrow Station offering tanning and spa services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including Hammer Strength machines and free weights. They also highlight the clean facilities and well-maintained machines.\n\nOther reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-90e4-767f-8d58-e6da616e5281.webp",
      "poi_featured_image_media": {
        "alt_text": "People working out on various machines in a brightly lit gym with purple accents.",
        "public_id": "019d72d0-90e4-767f-8d58-e6da616e5281",
        "storage_key": "property/6767906449167443/019d72d0-90e4-767f-8d58-e6da616e5281.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/morrow-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=15817431264051856267&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.566543",
      "poi_longitude": "-84.325381",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-472-2518",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d72d1-047e-716f-af8f-5e1c0d768d9b",
        "storage_key": "property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLbfUDHb59IgRiwP4KO7Ngts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6680192e-602e-499f-8244-6e257dd71b3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Fitness 2020 - Eagles Landing",
      "poi_type": "Health and Wellness",
      "poi_address": "200-200 Business Center Dr, Stockbridge, GA 30281, USA",
      "poi_short_description": "Modern gym featuring classes, free weights, exercise machines and a sauna.",
      "poi_long_description": "People say this gym offers a variety of equipment and has 24/7 access. They also highlight the friendly and professional staff, and the clean facilities.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-9849-74f8-9bd8-3aa9d21ea8cb.webp",
      "poi_featured_image_media": {
        "alt_text": "Spacious fitness center with cardio and weight machines.",
        "public_id": "019d72d0-9849-74f8-9bd8-3aa9d21ea8cb",
        "storage_key": "property/6767906449167443/019d72d0-9849-74f8-9bd8-3aa9d21ea8cb.webp",
        "width": 816,
        "height": 460
      },
      "poi_business_url": "https://fitness2020.com/locations/eagles-landing-home-page/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15919879138821848092&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitness-2020---eagles-landing",
      "poi_latitude": "33.5185974",
      "poi_longitude": "-84.20734159999999",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 678-565-8682",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d72d1-047e-716f-af8f-5e1c0d768d9b",
        "storage_key": "property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG8I7JnRX9IgRHLygyLrF7tw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_eac4f50d-a848-474d-82f1-7c2e87eb6214",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "5th Nail Lounge Morrow",
      "poi_type": "Health and Wellness",
      "poi_address": "7096 Mt Zion Blvd Suite 300, Jonesboro, GA 30236, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-9e2d-7435-bee2-c62f50d2f75d.webp",
      "poi_featured_image_media": {
        "alt_text": "Close up of hands with long, stiletto nails featuring a yellow, white, and black striped design with rhinestones.",
        "public_id": "019d72d0-9e2d-7435-bee2-c62f50d2f75d",
        "storage_key": "property/6767906449167443/019d72d0-9e2d-7435-bee2-c62f50d2f75d.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://5thnailloungemorrow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14697359684308959688&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "5th-nail-lounge-morrow",
      "poi_latitude": "33.5606263",
      "poi_longitude": "-84.3225326",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-452-4688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d72d1-047e-716f-af8f-5e1c0d768d9b",
        "storage_key": "property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wtuH5X59IgRyAFiT8OC98s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_ad9594bc-bbfa-4e7c-8f30-93aa0b2747d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Gloss Nail Bar",
      "poi_type": "Health and Wellness",
      "poi_address": "1357 Mt Zion Rd, Morrow, GA 30260, USA",
      "poi_short_description": "Relaxed nail salon with a bar-style setup offering a wide range of designs, including intricate nail art.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-9ce7-724e-aaf5-2309af09d4e5.webp",
      "poi_featured_image_media": {
        "alt_text": "Luxurious nail salon with rows of pedicure chairs and manicure stations, featuring a large chandelier.",
        "public_id": "019d72d0-9ce7-724e-aaf5-2309af09d4e5",
        "storage_key": "property/6767906449167443/019d72d0-9ce7-724e-aaf5-2309af09d4e5.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.glossnailbarmorrow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3541902514532959186&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gloss-nail-bar",
      "poi_latitude": "33.5704498",
      "poi_longitude": "-84.3463913",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-731-2349",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d72d1-047e-716f-af8f-5e1c0d768d9b",
        "storage_key": "property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL-bArLD59IgR0sPMN5JdJzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_9e2e6c2c-3a58-4352-99a9-2bf151a0d93f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Fellas And Females Barber Shop",
      "poi_type": "Health and Wellness",
      "poi_address": "2043 Mt Zion Rd, Morrow, GA 30260, USA",
      "poi_short_description": "Barber shop offering haircuts and grooming services in the heart of Morrow, Georgia.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-a149-748d-9226-26793f533bf4.webp",
      "poi_featured_image_media": {
        "alt_text": "Barber chairs lined up in a salon",
        "public_id": "019d72d0-a149-748d-9226-26793f533bf4",
        "storage_key": "property/6767906449167443/019d72d0-a149-748d-9226-26793f533bf4.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12924238680789600340&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fellas-and-females-barber-shop",
      "poi_latitude": "33.5614109",
      "poi_longitude": "-84.32442329999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-467-0286",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d72d1-047e-716f-af8f-5e1c0d768d9b",
        "storage_key": "property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsxhtDuL59IgRVMjTyJoeXLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_ec310757-701b-4ffa-98c1-fce9f2842c2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Piedmont Henry",
      "poi_type": "Health and Wellness",
      "poi_address": "1133 Eagles Landing Pkwy, Stockbridge, GA 30281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-a6a2-76cb-917b-8b240c1f01ea.webp",
      "poi_featured_image_media": {
        "alt_text": "Piedmont Hospital South Entrance",
        "public_id": "019d72d0-a6a2-76cb-917b-8b240c1f01ea",
        "storage_key": "property/6767906449167443/019d72d0-a6a2-76cb-917b-8b240c1f01ea.webp",
        "width": 2120,
        "height": 1192
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-henry-hospital?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MTI5OTY4NzQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16988970070758721226&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "piedmont-henry",
      "poi_latitude": "33.5111408",
      "poi_longitude": "-84.2271275",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-604-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-033b-751d-ac7f-43e325c0c842.webp",
      "poi_map_icon_media": {
        "alt_text": "H icon",
        "public_id": "019d72d1-033b-751d-ac7f-43e325c0c842",
        "storage_key": "property/6767906449167443/019d72d1-033b-751d-ac7f-43e325c0c842.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJBduprw5X9IgRygZRl0TyxOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ac17eff3-7f25-4b85-aff6-593d49867228",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Southern Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "11 Upper Riverdale Rd, Riverdale, GA 30274, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-aaf3-720a-be7a-e5f172b28ca9.webp",
      "poi_featured_image_media": {
        "alt_text": "Southern Regional Medical Center exterior view",
        "public_id": "019d72d0-aaf3-720a-be7a-e5f172b28ca9",
        "storage_key": "property/6767906449167443/019d72d0-aaf3-720a-be7a-e5f172b28ca9.webp",
        "width": 1200,
        "height": 801
      },
      "poi_business_url": "http://www.southernregional.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9937447318799646521&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southern-regional-medical-center",
      "poi_latitude": "33.5794457",
      "poi_longitude": "-84.3895388",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 770-991-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-033b-751d-ac7f-43e325c0c842.webp",
      "poi_map_icon_media": {
        "alt_text": "H icon",
        "public_id": "019d72d1-033b-751d-ac7f-43e325c0c842",
        "storage_key": "property/6767906449167443/019d72d1-033b-751d-ac7f-43e325c0c842.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJRTfSZYf79IgROf81g6_n6Ik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_8226b7c5-db92-40e3-911a-8c84f0fcb876",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Clayton County International Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2300 Hwy 138 SE, Jonesboro, GA 30236, USA",
      "poi_short_description": "Sprawling park with 200+ acres of trails & fishing lakes, along with summer swimming & waterslides.",
      "poi_long_description": "People say this park offers beautiful lakes, walking trails, a playground, a dog park, and grill areas. They highlight the clean and scenic environment, and the friendly pedestrians. They also like the ample parking and the variety of activities available, including a recreation center, obstacle courses, and a water park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-b52b-761a-a3fe-06ab2fc9cded.webp",
      "poi_featured_image_media": {
        "alt_text": "Serene lake with reflections of clouds and trees under a blue sky with fluffy clouds.",
        "public_id": "019d72d0-b52b-761a-a3fe-06ab2fc9cded",
        "storage_key": "property/6767906449167443/019d72d0-b52b-761a-a3fe-06ab2fc9cded.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.claytonparks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9568869863027960610&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clayton-county-international-park",
      "poi_latitude": "33.5352712",
      "poi_longitude": "-84.31534359999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-473-5425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-052d-72a5-b9f6-86a4a6063032.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree icon.",
        "public_id": "019d72d1-052d-72a5-b9f6-86a4a6063032",
        "storage_key": "property/6767906449167443/019d72d1-052d-72a5-b9f6-86a4a6063032.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJM48dBgH59IgRIuu4P3F0y4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_72ed794f-0ad8-4168-b726-bcdeab3ee0a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Eagles Landing Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Eagles Landing Way, Stockbridge, GA 30281, USA",
      "poi_short_description": "Eatery featuring 27 holes of championship golf plus a clubhouse with pools, tennis courts, dining rooms and an event venue.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-ac83-750d-8479-5d4ef5070947.webp",
      "poi_featured_image_media": {
        "alt_text": "Mansion-like building on a golf course.",
        "public_id": "019d72d0-ac83-750d-8479-5d4ef5070947",
        "storage_key": "property/6767906449167443/019d72d0-ac83-750d-8479-5d4ef5070947.webp",
        "width": 728,
        "height": 410
      },
      "poi_business_url": "https://www.eagleslandingcc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15731791346613371941&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eagles-landing-country-club",
      "poi_latitude": "33.5091873",
      "poi_longitude": "-84.21552659999999",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-389-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-0b6d-7025-95ef-f2ed83a98efc.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a person playing soccer",
        "public_id": "019d72d1-0b6d-7025-95ef-f2ed83a98efc",
        "storage_key": "property/6767906449167443/019d72d1-0b6d-7025-95ef-f2ed83a98efc.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJQwXfbBJX9IgRJUR0D-GMUto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_1b123653-387a-4676-acb2-a78d025147ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Village Park - Ellenwood",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "750 Fairview Rd, Ellenwood, GA 30294, USA",
      "poi_short_description": "Spacious park featuring a splash area, playground, football field and basketball courts.",
      "poi_long_description": "People say this park offers a playground, splash pad, walking trails, and picnic pavilions. They highlight the clean restrooms, ample parking, and large green spaces. They also like the friendly and laid-back vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-b2d1-734b-9eff-7959d299ba0d.webp",
      "poi_featured_image_media": {
        "alt_text": "Children playing on a large, modern playground with slides, climbing walls, and monkey bars under green canopies.",
        "public_id": "019d72d0-b2d1-734b-9eff-7959d299ba0d",
        "storage_key": "property/6767906449167443/019d72d0-b2d1-734b-9eff-7959d299ba0d.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://visithenrycountygeorgia.com/things_to_do/village-park-at-north-henry/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4804046525883166872&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "village-park---ellenwood",
      "poi_latitude": "33.6268659",
      "poi_longitude": "-84.25511220000001",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 770-288-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-052d-72a5-b9f6-86a4a6063032.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree icon.",
        "public_id": "019d72d1-052d-72a5-b9f6-86a4a6063032",
        "storage_key": "property/6767906449167443/019d72d1-052d-72a5-b9f6-86a4a6063032.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfwauKXJV9IgRmDC3w9xmq0I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f9453558-1249-4996-9bd6-df2a302d5a61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Reynolds Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5665 Reynolds Rd, Morrow, GA 30260, USA",
      "poi_short_description": "Vast natural wildlife & land conservation area combining rolling hills, forests & wetlands.",
      "poi_long_description": "Visitors say this nature preserve offers peaceful walking trails, a babbling brook, bridges, lakes, and plenty of benches to stop and rest. They also highlight the abundance of turtles, deer, and other wildlife, as well as the clean and well-maintained trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-c52e-75b6-a06c-fe60bd67e337.webp",
      "poi_featured_image_media": {
        "alt_text": "Wooden boardwalk winding through a lush green forest.",
        "public_id": "019d72d0-c52e-75b6-a06c-fe60bd67e337",
        "storage_key": "property/6767906449167443/019d72d0-c52e-75b6-a06c-fe60bd67e337.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.claytonparks.com/reynolds-nature-preserve/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13930681515852577434&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "reynolds-nature-preserve",
      "poi_latitude": "33.6011637",
      "poi_longitude": "-84.3469689",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-603-4188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-052d-72a5-b9f6-86a4a6063032.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree icon.",
        "public_id": "019d72d1-052d-72a5-b9f6-86a4a6063032",
        "storage_key": "property/6767906449167443/019d72d1-052d-72a5-b9f6-86a4a6063032.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQbfYPaL-9IgRmjp-3we5U8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_fc3cdf1f-4e00-4fd9-af6b-34a75234e12e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Clark Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "111 Davis Rd, Stockbridge, GA 30281, USA",
      "poi_short_description": "11+ acres offering modern play structures, a paved walking path, picnic areas & a grill.",
      "poi_long_description": "Visitors say this park offers walking trails, a playground, and a dog park, and they appreciate the clean facilities and peaceful atmosphere. They also highlight the food trucks that come on Tuesdays and the ice cream truck that often visits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-b5f0-759d-b69f-e81eb95cdcff.webp",
      "poi_featured_image_media": {
        "alt_text": "Children's playground with slides, climbing structures, and a bench.",
        "public_id": "019d72d0-b5f0-759d-b69f-e81eb95cdcff",
        "storage_key": "property/6767906449167443/019d72d0-b5f0-759d-b69f-e81eb95cdcff.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://stockbridgega.org/places",
      "poi_directions_map_url": "https://maps.google.com/?cid=4588128670713782063&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clark-community-park",
      "poi_latitude": "33.5497583",
      "poi_longitude": "-84.23611210000001",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-389-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-052d-72a5-b9f6-86a4a6063032.webp",
      "poi_map_icon_media": {
        "alt_text": "Black silhouette of a Christmas tree icon.",
        "public_id": "019d72d1-052d-72a5-b9f6-86a4a6063032",
        "storage_key": "property/6767906449167443/019d72d1-052d-72a5-b9f6-86a4a6063032.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLWAWd11W9IgRLx-ukbdOrD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2c223abf-c568-4a57-b0e4-1b05967c5c8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "TOTO USA Incorporated",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1155 Southern Rd, Morrow, GA 30260, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-b3fa-7528-b61d-c8cb8dc7afe9.webp",
      "poi_featured_image_media": {
        "alt_text": "Modern vessel sink with a waterfall faucet.",
        "public_id": "019d72d0-b3fa-7528-b61d-c8cb8dc7afe9",
        "storage_key": "property/6767906449167443/019d72d0-b3fa-7528-b61d-c8cb8dc7afe9.webp",
        "width": 1000,
        "height": 653
      },
      "poi_business_url": "http://www.totousa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18230755825470972541&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "toto-usa-incorporated",
      "poi_latitude": "33.563137",
      "poi_longitude": "-84.3524322",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-282-8686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d72d1-047e-716f-af8f-5e1c0d768d9b",
        "storage_key": "property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-bjzwlj59IgRfaIUJNWnAP0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0c53d598-969e-46f8-91fd-c660b63239a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "HD Supply",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2100 Anvil Block Rd, Forest Park, GA 30297, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-d851-71ea-b864-78434cebad4a.webp",
      "poi_featured_image_media": {
        "alt_text": "Signage indicating receiving hours, attention for drivers, and instruction to not touch or reach through the window.",
        "public_id": "019d72d0-d851-71ea-b864-78434cebad4a",
        "storage_key": "property/6767906449167443/019d72d0-d851-71ea-b864-78434cebad4a.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.hdsupply.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5420089015861461462&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hd-supply",
      "poi_latitude": "33.629754",
      "poi_longitude": "-84.3223412",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d72d1-047e-716f-af8f-5e1c0d768d9b",
        "storage_key": "property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu2BXFf7_9IgR1kFrOT4GOEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e653c6ee-87c9-44b1-bba6-8a6cf25bd5b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "USA Truck INC Atlanta Terminal",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2665 Campbell Blvd, Ellenwood, GA 30294, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-c913-75f0-9c3d-6507535d0e68.webp",
      "poi_featured_image_media": {
        "alt_text": "Modern reception area with polished concrete floors and a large desk.",
        "public_id": "019d72d0-c913-75f0-9c3d-6507535d0e68",
        "storage_key": "property/6767906449167443/019d72d0-c913-75f0-9c3d-6507535d0e68.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.dbschenker.com/usa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12300168599920213315&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "usa-truck-inc-atlanta-terminal",
      "poi_latitude": "33.6174435",
      "poi_longitude": "-84.3029999",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d72d1-047e-716f-af8f-5e1c0d768d9b",
        "storage_key": "property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuXIDonP_9IgRQ32oKyz6sqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e0b6cccd-7068-4e4e-8320-b171274e1a23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Gillem Enclave ID Card Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "KANE HALL, 1508 McPherson Ave Bldg 714, Forest Park, GA 30297, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-d8b4-765d-bf7c-7e7d510d98dd.webp",
      "poi_featured_image_media": {
        "alt_text": "Front entrance of Kane Hall, a brick building with a green roof.",
        "public_id": "019d72d0-d8b4-765d-bf7c-7e7d510d98dd",
        "storage_key": "property/6767906449167443/019d72d0-d8b4-765d-bf7c-7e7d510d98dd.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://idco.dmdc.osd.mil/idco/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7320259481153309571&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gillem-enclave-id-card-office",
      "poi_latitude": "33.6165836",
      "poi_longitude": "-84.34058399999999",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 404-469-7150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d72d1-047e-716f-af8f-5e1c0d768d9b",
        "storage_key": "property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsaWSToT-9IgRgwvUtTbJlmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_77c52f1b-3daa-4bea-a9c6-7944d963609e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "poi_name": "Almo Distribution",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7139 Southlake Pkwy SUITE B, Morrow, GA 30260, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-de97-767c-a45a-b64ad0a8d74a.webp",
      "poi_featured_image_media": {
        "alt_text": "Semi-trucks parked at a warehouse loading dock at sunset.",
        "public_id": "019d72d0-de97-767c-a45a-b64ad0a8d74a",
        "storage_key": "property/6767906449167443/019d72d0-de97-767c-a45a-b64ad0a8d74a.webp",
        "width": 3072,
        "height": 2173
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14444122836894571677&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "almo-distribution",
      "poi_latitude": "33.5595565",
      "poi_longitude": "-84.3403596",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle graphic",
        "public_id": "019d72d1-047e-716f-af8f-5e1c0d768d9b",
        "storage_key": "property/6767906449167443/019d72d1-047e-716f-af8f-5e1c0d768d9b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX_9pCUP59IgRnVw1ITHVc8g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_df4e1da64697b3470af7530e",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_576190218e834c226e48e6d9",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_bc0cfa45312c68ac8239ca6f",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_172ea3b3af2efd9b4fbd8b07",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3128668ec28ba5c2aade43ec",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d6e56a8ad0d1991a3b6b71f9",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_9807537bd806a95a94bf142b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "rating": "4",
      "name": "Life Of Miria",
      "text": "My experience living at NOVO Stockbridge has been truly excellent since the day I moved in  going on two years ago . The community is well-maintained but  what really sets this place apart is the incredible management team. I would like to specifically commend the consistent professionalism and genuine support provided by Ms. Ashley, Dominique, and Ms. Monica; they go above and beyond to ensure residents feel heard and valued. While I understand that individual experiences may vary, my time here has been consistently positive, and I am very happy with my decision to call this community home.\n\nI want to recognize the amazing Maintenance Supervisor Promis and the entire maintenance team at Novo Stockbridge Apartments. They are always professional, respectful, and quick to respond whenever a maintenance request is submitted. Every repair I’ve needed has been completed efficiently, and they always make sure the job is done right the first time.",
      "date": "2026-07-13",
      "title": "false"
    },
    {
      "id": "ec_b03180a351f85a396d9fa092",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "rating": "5",
      "name": "Lavantay Hudson",
      "text": "I literally love my unit. I’ve been staying here now for six months and the amenities are great. I literally have no outside bills besides my Georgia Power bill and my rental assurance so the amenities here are just French kiss, The associates in the rent office are so helpful, generous, kind, and understanding.. Even down to the maintenance guys I put a work order in one day they literally were at my door less than an hour to fix my problem.. I recommend these apartments to everyone I know.",
      "date": "2026-06-15",
      "title": "false"
    },
    {
      "id": "ec_61c9a61ab28ece4cd9d53899",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "rating": "5",
      "name": "Stephen James",
      "text": "I just moved into Novo Apartments and had such a great experience from the start. Dominique was absolutely amazing super helpful, patient, and made the whole process smooth and stress-free. She really took the time to answer all my questions and made me feel welcome right away.\n\nThe move-in process was easy, and so far everything has been exactly what I hoped for. If you’re thinking about moving here, I definitely recommend it. ask for Dominique, she’ll take great care of you!",
      "date": "2026-04-29",
      "title": "false"
    },
    {
      "id": "ec_9a981d465fd8ee23242f1103",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "rating": "5",
      "name": "Rae Fraser",
      "text": "I have been living at Novo since they opened. The new management is doing an amazing job. Monika is absolutely friendly, it is always a pleasure to speak with her and she always addresses all my concerns. Living here has been a true joy and I truly appreciate all the changes the new management team is making.",
      "date": "2026-06-11",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_bb5553e0-3fbd-450a-8572-7adadcf00589",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-6895-7099-b565-9a2a2b321d66.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d72d0-6895-7099-b565-9a2a2b321d66",
        "storage_key": "property/6767906449167443/019d72d0-6895-7099-b565-9a2a2b321d66.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A1 Floorplan",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=m3gkvBRUPGE&play=1"
    },
    {
      "id": "custom_402e9544-3831-4f96-99ec-2a29b4eede67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-6895-7099-b565-9e268de9960d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d72d0-6895-7099-b565-9e268de9960d",
        "storage_key": "property/6767906449167443/019d72d0-6895-7099-b565-9e268de9960d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B1 Floorplan",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=wPG8V9oSTDg&play=1"
    },
    {
      "id": "custom_ecb3fd0b-cad9-498a-8adf-3d0f2d4e9132",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167443/019d72d0-68a7-764d-a997-691c65ced8c4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d72d0-68a7-764d-a997-691c65ced8c4",
        "storage_key": "property/6767906449167443/019d72d0-68a7-764d-a997-691c65ced8c4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "C1 Floorplan",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=g8eMAh6pedt&play=1"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db23f-daf3-71dc-bba8-2179ac0b7126",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Novo Stockbridge Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443"
    },
    {
      "lead_collector_id": "019db23f-db66-74c9-b979-d82aa178c2f7",
      "lead_source": "FACEBOOK_ADS",
      "name": "Novo Stockbridge Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443"
    },
    {
      "lead_collector_id": "019db23f-dbda-70bd-a35f-7fc6745510d5",
      "lead_source": "LANDING_PAGE",
      "name": "Novo Stockbridge Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "page_item_url": "in-unit-washer-dryer-apartments-stockbridge",
      "search_query": "apartments with in-unit washer dryer Stockbridge",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Washer Dryer",
      "h2_subtitle": "Find top apartments with in-unit washer dryers at NOVO Stockbridge. Enjoy modern living with convenient amenities in the heart of Stockbridge.",
      "page_copy": "NOVO Stockbridge offers apartments with in-unit washer and dryer in Stockbridge, GA. The community provides a variety of floor plans with features designed for everyday living.\nApartment homes include stainless steel appliances and movable kitchen islands. Additional options such as garage parking and extra storage are available. Select homes also include garden tubs.\nThe community is located in Clayton County near shopping, dining, entertainment, and major roadways, providing convenient access to local destinations and services.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Washer Dryer in Stockbridge",
      "seo_description": "Explore NOVO Stockbridge's apartments featuring in-unit washer dryers. Experience modern amenities and convenient living in Stockbridge, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "page_item_url": "luxury-apartments-pools-clayton-county",
      "search_query": "luxury apartments with pools Clayton County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pools",
      "h2_subtitle": "Discover luxury living at NOVO Stockbridge with exclusive pool access. Experience upscale amenities in Clayton County's vibrant community.",
      "page_copy": "NOVO Stockbridge offers apartments with pool access in Clayton County, GA. The community includes a variety of floor plans with features designed for everyday living.\nApartment homes include stainless steel appliances, movable kitchen islands, garden tubs, and options for garage parking and additional storage. Residents also have access to a swimming pool and outdoor fire pits.\nLocated in Stockbridge, GA, the community provides convenient access to nearby shopping, dining, entertainment, and major roadways throughout Clayton County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pools in Clayton County",
      "seo_description": "Explore NOVO Stockbridge's luxury apartments with pools. Enjoy premium amenities and stylish living in Clayton County's sought-after community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "page_item_url": "dog-friendly-apartments-near-30281",
      "search_query": "dog-friendly apartments near 30281",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments Near 30281",
      "h2_subtitle": "Explore NOVO Stockbridge's pet-friendly community, conveniently located near the 30281 area. Enjoy modern amenities and a great location.",
      "page_copy": "At NOVO Stockbridge, we offer dog-friendly apartments near the 30281 area, ensuring both you and your furry companion find the perfect place to call home. Our community is designed with both comfort and convenience in mind, featuring modern amenities such as outdoor fire pits, stainless steel appliances, and more.\nYour pet will love exploring our welcoming grounds while you enjoy the luxury of our spacious units, which come equipped with movable kitchen islands and garden tubs. In addition to being pet-friendly, NOVO Stockbridge provides extra conveniences like garages and storage closets. Nestled in the vibrant area of Stockbridge, GA, our community provides you with easy access to local pet-friendly parks and more. Come see why we are the ideal choice for you and your four-legged friend!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments Near 30281",
      "seo_description": "Discover dog-friendly apartments at NOVO Stockbridge near 30281. Enjoy modern living with amenities designed for you and your pet's comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-georgia",
      "search_query": "state-of-the-art fitness center apartments Georgia",
      "category": "Amenity",
      "h1_title": "State-of-the-Art Fitness Center Apartments",
      "h2_subtitle": "Enjoy top-notch fitness facilities at NOVO Stockbridge in Georgia. Our community offers modern living with exclusive amenities.",
      "page_copy": "NOVO Stockbridge offers apartments with a fitness center in Stockbridge, GA. The community includes a fitness center and a variety of amenities for everyday living.\nApartment homes feature stainless steel appliances and movable kitchen islands. Select homes include garden tubs. Additional options include garage parking and storage closets.\nLocated in Clayton County, the community provides convenient access to nearby shopping, dining, entertainment, and major roadways throughout the Stockbridge area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "State-of-the-Art Fitness Center Apartments",
      "seo_description": "Discover Georgia apartments with a state-of-the-art fitness center at NOVO Stockbridge. Enjoy modern amenities and a prime location in Stockbridge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "page_item_url": "garden-tubs-stockbridge-apartments",
      "search_query": "garden tubs in Stockbridge apartments",
      "category": "Amenity",
      "h1_title": "Garden Tubs in Stockbridge Apartments",
      "h2_subtitle": "Relax in luxurious garden tubs at NOVO Stockbridge. Experience comfort and elegance in our modern Stockbridge, GA, apartments.",
      "page_copy": "NOVO Stockbridge offers apartments in Stockbridge, GA with garden tubs in select homes. Apartment features include stainless steel appliances and movable kitchen islands.\nThe community also provides outdoor fire pits, garage parking options, and additional storage closets. Located in Stockbridge, GA, the property offers convenient access to nearby shopping, dining, entertainment, and major roadways throughout Clayton County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Garden Tubs in Stockbridge Apartments",
      "seo_description": "Find Stockbridge apartments with luxurious garden tubs at NOVO Stockbridge. Discover comfort and modern amenities in a prime Stockbridge location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-stockbridge-ga",
      "search_query": "one bedroom apartments in Stockbridge GA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Stockbridge, GA",
      "h2_subtitle": "Discover modern living at NOVO Stockbridge in our one bedroom apartments. Enjoy stylish amenities and a prime Stockbridge, GA, location.",
      "page_copy": "NOVO Stockbridge offers one-bedroom apartments in Stockbridge, GA. Apartment homes include stainless steel appliances and movable kitchen islands, along with features designed for everyday living.\nThe community also offers outdoor fire pits, garage parking options, and additional storage closets. Located in Clayton County, the property provides convenient access to nearby parks, shopping, dining, and major roadways throughout the Stockbridge area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Stockbridge, GA",
      "seo_description": "Explore stylish one bedroom apartments in Stockbridge, GA, at NOVO Stockbridge. Modern amenities and a prime location await you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-clayton-county",
      "search_query": "two bedroom apartments near Clayton County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Clayton County",
      "h2_subtitle": "Explore spacious two bedroom apartments at NOVO Stockbridge. Enjoy modern amenities just minutes from Clayton County's vibrant offerings.",
      "page_copy": "NOVO Stockbridge offers two-bedroom apartments in Stockbridge, GA with convenient access to Clayton County. Apartment homes include stainless steel appliances and movable kitchen islands, along with features designed for everyday living.\nThe community provides outdoor fire pits, garage parking options, and additional storage closets. Located in Stockbridge, GA, the property offers convenient access to nearby shopping, dining, entertainment, and major roadways throughout the area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Clayton County",
      "seo_description": "Find modern two bedroom apartments near Clayton County at NOVO Stockbridge. Enjoy spacious living with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-30281",
      "search_query": "three bedroom apartments in 30281",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in 30281",
      "h2_subtitle": "Discover spacious three bedroom apartments at NOVO Stockbridge. Enjoy modern living in the heart of the 30281 area.",
      "page_copy": "At NOVO Stockbridge, our three bedroom apartments provide ample space and modern amenities, perfect for families or those in need of extra room in the 30281 zip code area. Each apartment comes equipped with stainless steel appliances and features like movable kitchen islands, designed to accommodate a contemporary lifestyle.\n\nThe community facilities at NOVO Stockbridge enhance your living experience with outdoor fire pits, and options for garages and storage closets, ensuring convenience and comfort are at your fingertips. Situated in a prime location, residents enjoy proximity to local shopping, dining, and entertainment in Stockbridge. Choose the spacious and modern living experience offered by the three bedroom apartments at NOVO Stockbridge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in 30281",
      "seo_description": "Explore spacious three bedroom apartments in the 30281 area at NOVO Stockbridge. Enjoy modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "page_item_url": "apartments-near-clayton-state-university-stockbridge",
      "search_query": "apartments close to clayton state university stockbridge",
      "category": "School",
      "h1_title": "Apartments Close to Clayton State University",
      "h2_subtitle": "Find ideal student accommodation at NOVO Stockbridge, located just a short drive from Clayton State University in Stockbridge.",
      "page_copy": "NOVO Stockbridge offers apartments in Stockbridge, GA near Clayton State University. The community provides convenient access to nearby educational institutions, major employers, and local destinations throughout Clayton County.\nApartment homes include stainless steel appliances and movable kitchen islands, along with features designed for everyday living. The community also offers outdoor fire pits, garage parking options, and additional storage closets. Located in Stockbridge, GA, residents have access to nearby shopping, dining, entertainment, and major roadways.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Clayton State University",
      "seo_description": "Live near Clayton State University at NOVO Stockbridge. Modern apartments with student-focused amenities in a prime Stockbridge location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "page_item_url": "apartments-near-piedmont-henry-hospital-stockbridge-ga",
      "search_query": "apartments near Piedmont Henry hospital Stockbridge GA",
      "category": "Hospital",
      "h1_title": "Apartments Near Piedmont Henry Hospital",
      "h2_subtitle": "Experience convenient living at NOVO Stockbridge, just moments from Piedmont Henry Hospital in Stockbridge, GA.",
      "page_copy": "NOVO Stockbridge offers apartments near Piedmont Henry Hospital in Stockbridge, GA. The community provides convenient access to major employers, local services, and destinations throughout Clayton County.\nApartment homes include stainless steel appliances and movable kitchen islands, along with features designed for everyday living. The community also offers outdoor fire pits, garage parking options, and additional storage closets. Located in Stockbridge, GA, residents have access to nearby shopping, dining, entertainment, and major roadways throughout the area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Piedmont Henry Hospital GA",
      "seo_description": "Discover modern living at NOVO Stockbridge, near Piedmont Henry Hospital. Enjoy spacious apartments with top amenities in Stockbridge, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "page_item_url": "apartments-near-clayton-county-international-park-ga",
      "search_query": "apartments near Clayton County International Park GA",
      "category": "Park",
      "h1_title": "Apartments Near Clayton County International Park",
      "h2_subtitle": "Discover NOVO Stockbridge's prime location near Clayton County International Park, offering modern living and vibrant community amenities.",
      "page_copy": "NOVO Stockbridge offers apartments near Clayton County International Park in Stockbridge, GA. The community provides convenient access to nearby parks, recreation areas, shopping, dining, and entertainment throughout Clayton County.\nApartment homes include stainless steel appliances and movable kitchen islands, along with features designed for everyday living. The community also offers outdoor fire pits, garage parking options, and additional storage closets. Located in Stockbridge, GA, res\nNOVO Stockbridge offers apartments near Clayton County International Park in Stockbridge, GA. The community provides convenient access to nearby parks, recreation areas, shopping, dining, and entertainment throughout Clayton County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Clayton County International Park GA",
      "seo_description": "Live close to Clayton County International Park at NOVO Stockbridge. Offering modern apartments with top amenities in a vibrant community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "page_item_url": "stockbridge-rentals-near-village-park-ellenwood",
      "search_query": "Stockbridge rentals close to Village Park Ellenwood",
      "category": "Park",
      "h1_title": "Rentals Close to Village Park Ellenwood",
      "h2_subtitle": "Explore the charm of NOVO Stockbridge rentals, conveniently located near Village Park Ellenwood for easy access to local leisure activities.",
      "page_copy": "NOVO Stockbridge offers apartments near Village Park in Stockbridge, GA. The community provides convenient access to nearby parks, recreation areas, shopping, dining, and entertainment throughout Clayton County.\nApartment homes include stainless steel appliances and movable kitchen islands, along with features designed for everyday living. The community also offers outdoor fire pits, garage parking options, and additional storage closets. Located in Stockbridge, GA, residents have access to major roadways and local destinations throughout the surrounding area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stockbridge Rentals Near Village Park Ellenwood",
      "seo_description": "Discover NOVO Stockbridge rentals near Village Park Ellenwood, offering modern amenities and easy access to outdoor recreation in Stockbridge.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167443",
      "source": "custom",
      "page_item_url": "clark-community-park-nearby-apartments-clayton-county",
      "search_query": "Clark Community Park nearby apartments Clayton County",
      "category": "Park",
      "h1_title": "Apartments Near Clark Community Park",
      "h2_subtitle": "Find your home at NOVO Stockbridge, located near Clark Community Park in Clayton County, offering a perfect blend of comfort and convenience.",
      "page_copy": "NOVO Stockbridge offers apartments near Village Park in Stockbridge, GA. The community provides convenient access to nearby parks, recreation areas, shopping, dining, and entertainment throughout Clayton County.\nApartment homes include stainless steel appliances and movable kitchen islands, along with features designed for everyday living. The community also offers outdoor fire pits, garage parking options, and additional storage closets. Located in Stockbridge, GA, residents have access to major roadways and local destinations throughout the surrounding area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Clark Community Park Clayton County",
      "seo_description": "Discover the comfort of NOVO Stockbridge near Clark Community Park, offering modern apartments and easy access to Clayton County's outdoor charm.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6080"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11671074700"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WDW4MKGD"
    },
    {
      "ID": "custom_entrata_chatbot",
      "type": "STRING",
      "value": "<script>Object.assign(window, {websiteToken: 'vNz1X8yXonZdQNwGaC7mHuiG', siteConfig: {clt_i: \"102052\", property_id: \"100160106\"}});</script><script src=\"https://commoncf.entrata.com/javascript/comms/init.js?ver=1671933\"></script>"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "9863957055"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "26e27e11f0df1447"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "b484f0cc984e11eebcb40e136090bd39"
    },
    {
      "ID": "custom_call_rail_company_id",
      "type": "STRING",
      "value": "466252548"
    },
    {
      "ID": "custom_call_rail_account_hash",
      "type": "STRING",
      "value": "eb9458a66dce52f3272c"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "3f4c3fd2-e689-11f0-b8e1-fb177cb72388"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/3f4c3fd2-e689-11f0-b8e1-fb177cb72388/tour"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im5GNko3WkJLSXhxeGpnSUxLMERSUFE9PSIsInZhbHVlIjoiaWF6NWpGRG8zZmx4bVAzZG4xY20xdz09IiwibWFjIjoiZDhkZTY5YmVlZWI2NzgyMDFiM2UxZjQyZjRlODM4N2I3ZWE3OGZhM2JhOTBkMDE0ZjA2NzkxYmRjNTMxNzBjZSJ9"
    }
  ],
  "custom_qb_id": "6080",
  "custom_repli_id": "11671074700",
  "custom_google_gtm_id": "GTM-WDW4MKGD",
  "custom_entrata_chatbot": "<script>Object.assign(window, {websiteToken: 'vNz1X8yXonZdQNwGaC7mHuiG', siteConfig: {clt_i: \"102052\", property_id: \"100160106\"}});</script><script src=\"https://commoncf.entrata.com/javascript/comms/init.js?ver=1671933\"></script>",
  "custom_hubspot_company_id": "9863957055",
  "custom_knock_community_id": "26e27e11f0df1447",
  "custom_knock_company_token": "b484f0cc984e11eebcb40e136090bd39",
  "custom_call_rail_company_id": "466252548",
  "custom_call_rail_account_hash": "eb9458a66dce52f3272c",
  "custom_eliseai_building_token": "3f4c3fd2-e689-11f0-b8e1-fb177cb72388",
  "custom_eliseai_organization_id": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/3f4c3fd2-e689-11f0-b8e1-fb177cb72388/tour",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im5GNko3WkJLSXhxeGpnSUxLMERSUFE9PSIsInZhbHVlIjoiaWF6NWpGRG8zZmx4bVAzZG4xY20xdz09IiwibWFjIjoiZDhkZTY5YmVlZWI2NzgyMDFiM2UxZjQyZjRlODM4N2I3ZWE3OGZhM2JhOTBkMDE0ZjA2NzkxYmRjNTMxNzBjZSJ9",
  "custom_audioeye_site_id": "be9ecf97-fda6-4871-a68d-efd089c61b4a",
  "custom_audioeye_site_hash": "eaee17a35e2a2b786c87cf45989d8160"
};

export const generatedAt = '2026-10-01T17:22:54.557Z';
